import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@mui/material";
import { useMemo } from "react";
import { RadioGroup, FormControl, FormControlLabel, Radio } from "@mui/material";

import {
    Button,
    TextField,
    Snackbar,
    LinearProgress,
    Alert,
    Box,
    Typography,
    Paper,
    ThemeProvider,
    createTheme,
    CssBaseline,
    MenuItem,

} from "@mui/material";
import logo from "./Images/Isgec.png";

const theme = createTheme({
    palette: {
        mode: "light",
        primary: { main: "#1976d2" },
        secondary: { main: "#00bcd4" },
        background: { default: "#ffffff", paper: "#f5f5f5" },
        error: { main: "#f44336" },
    },
    typography: {
        fontFamily: "Roboto, sans-serif",
        h5: { fontWeight: 600 },
        button: { fontSize: "1rem", textTransform: "none" },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    transition: "0.3s",
                    backgroundColor: "#add8e6",
                    color: "#000",
                    '&:hover': {
                        backgroundColor: "#87cefa",
                        color: "#000",
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                    boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                    border: "none",
                },
            },
        },
        // Removed global maxWidth for TextField/Select as we'll handle it per-component
        // to be more flexible and responsive to the new grid layout.
    },
});


const InventorControlPanel = () => {
    const baseUrl = "http://localhost:5050";

    const [loading, setLoading] = useState(false);
    const [agentStatus, setAgentStatus] = useState("Checking application status...");
    const [showInstallMsg, setShowInstallMsg] = useState(false);
    const [selectedStage, setSelectedStage] = useState("Common");
    const [thermalTab, setThermalTab] = useState(0);
    const [detailingTab, setDetailingTab] = useState(0);
    const [headerTab, setHeaderTab] = useState(0);
    const [mainThermalTab, setMainThermalTab] = useState(0);
    const [mainDetailTab, setMainDetailTab] = useState(0);

    //const [imageSrc, setImageSrc] = useState(require("./Images/Default.png"));
    const DEFAULT_IMAGE = require("./Images/Default.png");
    const [imageSrc, setImageSrc] = useState(DEFAULT_IMAGE);



    //const start1ImageMap = useMemo(() => ({
    //    1: require("./Images/Stub1_Typ1_Top.png"),
    //    2: require("./Images/Stub1_Typ2_Top.png"),
    //}), []);

    //const start2ImageMap = useMemo(() => ({
    //    1: require("./Images/Stub2_Typ1_Top.png"),
    //    2: require("./Images/Stub2_Typ2_Top.png"),
    //}), []);

    //const start3ImageMap = useMemo(() => ({
    //    1: require("./Images/Stub3_Typ1_Top.png"),
    //    2: require("./Images/Stub3_Typ2_Top.png"),
    //}), []);

    //const start4ImageMap = useMemo(() => ({
    //    1: require("./Images/Stub4_Typ1_Top.png"),
    //    2: require("./Images/Stub4_Typ2_Top.png"),
    //}), []);

    //const start5ImageMap = useMemo(() => ({
    //    1: require("./Images/Stub5_Typ1_Top.png"),
    //    2: require("./Images/Stub5_Typ2_Top.png"),
    //}), []);

    //const start1ImageMap_Btm = useMemo(() => ({
    //    1: require("./Images/Stub1_Typ1_Bottom.png"),
    //    2: require("./Images/Stub1_Typ2_Bottom.png"),
    //}), []);

    //const start2ImageMap_Btm = useMemo(() => ({
    //    1: require("./Images/Stub2_Typ1_Bottom.png"),
    //    2: require("./Images/Stub2_Typ2_Bottom.png"),
    //}), []);

    //const start3ImageMap_Btm = useMemo(() => ({
    //    1: require("./Images/Stub3_Typ1_Bottom.png"),
    //    2: require("./Images/Stub3_Typ2_Bottom.png"),
    //}), []);

    //const start4ImageMap_Btm = useMemo(() => ({
    //    1: require("./Images/Stub4_Typ1_Bottom.png"),
    //    2: require("./Images/Stub4_Typ2_Bottom.png"),
    //}), []);

    //const start5ImageMap_Btm = useMemo(() => ({
    //    1: require("./Images/Stub5_Typ1_Bottom.png"),
    //    2: require("./Images/Stub5_Typ2_Bottom.png"),
    //}), []);

    const modularStartImages = useMemo(() => ({
        "1": require("./Images/No_of_Start_1.png"),
        "2": require("./Images/No_of_Start_2.png"),
        "3": require("./Images/No_of_Start_3.png"),
        "4": require("./Images/No_of_Start_4.png"),
        "5": require("./Images/No_of_Start_5.png"),
    }), []);

    const nonModularStartImages = useMemo(() => ({
        "1": require("./Images/Despatch_1.png"),
        "2": require("./Images/Despatch_2.png"),
        "3": require("./Images/Despatch_3.png"),
        "4": require("./Images/Despatch_4.png"),
        "5": require("./Images/Despatch_5.png"),
    }), []);

    const tubeTypeImageMap = useMemo(() => ({
        Finned: require("./Images/Finned_Tube.png"),
        Plain: require("./Images/Plain_Tube.png"),
    }), []);

    const headerPositionBtmImageMap = useMemo(() => ({
        LHS: require("./Images/Header_Position_LHS_Btm.png"),
        RHS: require("./Images/Header_Position_RHS_Btm.png"),
    }), []);

    const headerPositionTopImageMap = useMemo(() => ({
        LHS: require("./Images/Header_Position_LHS_Top.png"),
        RHS: require("./Images/Header_Position_RHS_Top.png"),
    }), []);


    const TYPE_OF_FLOW_IMAGES = useMemo(() => ({
        AQC: {
            Parallel: require("./Images/Type_Of_Flow_Parallel_For_AQC.png"),
            Counter: require("./Images/Type_Of_Flow_Counter_For_AQC.png"),
        },
        PH: {
            Parallel: require("./Images/Type_Of_Flow_Parallel_For_PH.png"),
            Counter: require("./Images/Type_Of_Flow_Counter_For_PH.png"),
        },
    }), []);


    //const bankTypeImageMap = useMemo(() => ({
    //    Single: require("./Images/bank-single.png"),
    //    Multiple: require("./Images/bank-multiple.png"),
    //}), []);

    const partitionImageMap = useMemo(() => ({
        "1": require("./Images/Coil_Rows_covered_in_Partition_Plate_1.png"),
        "2": require("./Images/Coil_Rows_covered_in_Partition_Plate_2.png"),
        "3": require("./Images/Coil_Rows_covered_in_Partition_Plate_3.png"),
    }), []);

    const partitionImageMap_Btm = useMemo(() => ({
        "1": require("./Images/Coil_Rows_covered_in_Partition_Plate_1.png"),
        "2": require("./Images/Coil_Rows_covered_in_Partition_Plate_2.png"),
        "3": require("./Images/Coil_Rows_covered_in_Partition_Plate_3.png"),
    }), []);

    const headerLocationTopImageMap = useMemo(() => ({
        LHS: {
            In_Side_Casing: require("./Images/Header_Location_LHS_Inside_Casing_Top.png"),
            Out_Side_Casing: require("./Images/Header_Location_LHS_Outside_Casing_Top.png"),
        },
        RHS: {
            In_Side_Casing: require("./Images/Header_Location_RHS_Inside_Casing_Top.png"),
            Out_Side_Casing: require("./Images/Header_Location_RHS_Outside_Casing_Top.png"),
        },
    }), []);

    const headerLocationBtmImageMap = useMemo(() => ({
        LHS: {
            In_Side_Casing: require("./Images/Header_Location_LHS_Inside_Casing_Btm.png"),
            Out_Side_Casing: require("./Images/Header_Location_LHS_Outside_Casing_Btm.png"),
        },
        RHS: {
            In_Side_Casing: require("./Images/Header_Location_RHS_Inside_Casing_Btm.png"),
            Out_Side_Casing: require("./Images/Header_Location_RHS_Outside_Casing_Btm.png"),
        },
    }), []);


    const headerLocationDetTopImageMap = useMemo(() => ({
        LHS: {
            In_Side_Casing: require("./Images/Header_Location_LHS_Inside_Casing_Top_Det.png"),
            Out_Side_Casing: require("./Images/Header_Location_LHS_Outside_Casing_Top_Det.png"),
        },
        RHS: {
            In_Side_Casing: require("./Images/Header_Location_RHS_Inside_Casing_Top_Det.png"),
            Out_Side_Casing: require("./Images/Header_Location_RHS_Outside_Casing_Top_Det.png"),
        },
    }), []);

    const headerLocationDetBtmImageMap = useMemo(() => ({
        LHS: {
            In_Side_Casing: require("./Images/Header_Location_LHS_Inside_Casing_Btm_Det.png"),
            Out_Side_Casing: require("./Images/Header_Location_LHS_Outside_Casing_Btm_Det.png"),
        },
        RHS: {
            In_Side_Casing: require("./Images/Header_Location_RHS_Inside_Casing_Btm_Det.png"),
            Out_Side_Casing: require("./Images/Header_Location_RHS_Outside_Casing_Btm_Det.png"),
        },
    }), []);

    const noOfSupportsImageMap = useMemo(() => ({
        "2": require("./Images/No_of_Supports_2.png"),
        "3": require("./Images/No_of_Supports_3.png"),
        "4": require("./Images/No_of_Supports_4.png"),
        "5": require("./Images/No_of_Supports_5.png"),
    }), []);


    const noOfSetImageMap = useMemo(() => ({
        "Single": require("./Images/No_of_Set_1.png"),
        "Double": require("./Images/No_of_Set_2.png"),
    }), []);


    const hammeringPosImageMap = useMemo(() => ({
        Single: {
            RHS: require("./Images/Hammering_Pos_Single_RHS.png"),
            LHS: require("./Images/Hammering_Pos_Single_LHS.png"),
            BOTH: require("./Images/Hammering_Pos_Single_BOTH.png"),
        },
        Double: {
            RHS: require("./Images/Hammering_Pos_Double_RHS.png"),
            LHS: require("./Images/Hammering_Pos_Double_LHS.png"),
            BOTH: require("./Images/Hammering_Pos_Double_BOTH.png"),
        },
    }), []);

    const HEADER_STUB_ANGLE_TOP_IMAGES = useMemo(() => ({
        STUB1: {
            LHS: require("./Images/Header_Stub1_Angle_LHS_Top.png"),
            RHS: require("./Images/Header_Stub1_Angle_RHS_Top.png"),
        },
        STUB2_5: {
            LHS: require("./Images/Header_Stub_Angle_LHS_Top2_5.png"),
            RHS: require("./Images/Header_Stub_Angle_RHS_Top2_5.png"),
        },
    }), []);

    const HEADER_STUB_ANGLE_BOTTOM_IMAGES = useMemo(() => ({
        STUB1: {
            LHS: require("./Images/Header_Stub1_Angle_LHS_Btm.png"),
            RHS: require("./Images/Header_Stub1_Angle_RHS_Btm.png"),
        },
        STUB2_5: {
            LHS: require("./Images/Header_Stub_Angle_LHS_Btm2_5.png"),
            RHS: require("./Images/Header_Stub_Angle_RHS_Btm2_5.png"),
        },
    }), []);


    const STUB_END_POINT_IMAGES = {
        LHS: {
            1: "TOP_LHS_STUB_END_POINT_DISTANCE",
            2: "TOP_LHS_STUB_END_POINT_DISTANCE_TYPE2",
        },
        RHS: {
            1: "TOP_RHS_STUB_END_POINT_DISTANCE",
            2: "TOP_RHS_STUB_END_POINT_DISTANCE_TYPE2",
        }
    };

    const STUB_END_POINT_BTM_IMAGES = {
        LHS: {
            1: "BOTTOM_LHS_STUB_END_POINT_DISTANCE",
            2: "BOTTOM_LHS_STUB_END_POINT_DISTANCE_TYPE2",
        },
        RHS: {
            1: "BOTTOM_RHS_STUB_END_POINT_DISTANCE",
            2: "BOTTOM_RHS_STUB_END_POINT_DISTANCE_TYPE2",
        }
    };


    const HEADER_CONNECTION_IMAGE_MAP = useMemo(() => ({
        "Branch Connection": require("./Images/Header_Connection_Branch_Connection.png"),
        "End Connection": require("./Images/Header_Connection_End_Connection.png"),
    }), []);

    const noOfFieldWeldImageMap = useMemo(() => ({
        "1": require("./Images/No_of_Field_Weld_1.png"),
        "2": require("./Images/No_of_Field_Weld_2.png"),
        "3": require("./Images/No_of_Field_Weld_3.png"),

    }), []);

    const expPadLocationBtmImageMap = useMemo(() => ({
        Header: require("./Images/Expansion_Indicator_Pad_Location_Header.png"),
        "Inspection Nozzle": require(
            "./Images/Expansion_Indicator_Pad_Location_Inspection_Branch.png"
        ),
    }), []);


    const branchTypeTopImageMap = useMemo(() => ({
        Straight: {
            LHS: require("./Images/Branch_Type_Straight_Top_LHS.png"),
            RHS: require("./Images/Branch_Type_Straight_Top_RHS.png"),
        },
        Bend: {
            LHS: require("./Images/Branch_Type_Bend_Top_LHS.png"),
            RHS: require("./Images/Branch_Type_Bend_Top_RHS.png"),
        },
    }), []);

    const branchTypeBtmImageMap = useMemo(() => ({
        Straight: {
            LHS: require("./Images/Branch_Type_Straight_Btm_LHS.png"),
            RHS: require("./Images/Branch_Type_Straight_Btm_RHS.png"),
        },
        Bend: {
            LHS: require("./Images/Branch_Type_Bend_Btm_LHS.png"),
            RHS: require("./Images/Branch_Type_Bend_Btm_RHS.png"),
        },
    }), []);

    const handleImageChange = (label) => {
        try {
            const img = require(`./Images/${label}.png`);
            setImageSrc(img);
        } catch (error) {
            setImageSrc(require("./Images/Default.png")); // fallback
        }
    };



    const [snack, setSnack] = useState({ open: false, message: "", severity: "success" });

    const [folderOptions, setFolderOptions] = useState([]);

    const handleChooseFolder = async () => {
        try {
            // Ask user to pick a folder
            const dirHandle = await window.showDirectoryPicker();
            const folders = [];

            for await (const entry of dirHandle.values()) {
                if (entry.kind === "directory" && /_(\d+|-)$/.test(entry.name)) {
                    folders.push(entry.name);
                }
            }

            setFolderOptions(folders);
        } catch (err) {
            console.error("Folder selection cancelled or failed:", err);
        }

    };

    // --- State variables for ALL Parameters (Common, Thermal, GA Assembly, Detailing) ---
    // Common Stage
    const [projectId, setProjectId] = useState("JB1246");
    const [title, setTitle] = useState("A & D of HP Evaporator-1");
    const [capacity, setCapacity] = useState("26");
    const [standard, setStandard] = useState("IBR");
    const [boilerType, setBoilerType] = useState("AQC");
    const [group, setGroup] = useState("Boilers");
    const [department, setDepartment] = useState("Mechanical");
    const [iwt, setIWT] = useState("IWT-6821");

    // Thermal Stage
    const [componentName_Thr, setComponentName_Thr] = useState("");
    //Common
    const [componentName, setComponentName] = useState("New");
    const [pressure, setPressure] = useState("HP");
    const [name1, setName1] = useState("Superheater");
    const [compNo, setCompNo] = useState("2");
    const [noOfStart1, setNoOfStart1] = useState("5");
    const [despatch, setDespatch] = useState("Modular");

    const [drawingNo, setDrawingNo] = useState("");

    //useEffect(() => {
    //    if (!selectedStage) {
    //        setImageSrc(require("./Images/Default.png"));
    //    }
    //}, [selectedStage]);

    useEffect(() => {
        if (projectId) {
            setDrawingNo(projectId + "-50991000-THD-0002");
        } else {
            setDrawingNo("");
        }
    }, [projectId]);


    // For Tube tab

    const [tubeOd, setTubeOd] = useState("38.1");
    const [tubeThk, setTubeThk] = useState("2.5");

    const [tubeType, setTubeType] = useState("-");

    useEffect(() => {

        if (despatch === "Modular" && modularStartImages[noOfStart1]) {
            setImageSrc(modularStartImages[noOfStart1]);
            return;
        }

        if (despatch === "Non Modular" && nonModularStartImages[noOfStart1]) {
            setImageSrc(nonModularStartImages[noOfStart1]);
            return;
        }

        //setImageSrc(""); // fallback
    }, [despatch, noOfStart1, modularStartImages, nonModularStartImages]);

    //useEffect(() => {
    //    if (boilerType === "PH") {
    //        setTubeType("Plain");
    //    }
    //}, [boilerType]);


    useEffect(() => {
        if (selectedStage === "Thermal" && thermalTab === 1) {

            if (boilerType === "PH") {
                setTubeType("Plain");
            }
            if (tubeType && tubeTypeImageMap[tubeType]) {
                setImageSrc(tubeTypeImageMap[tubeType]);
            }

        }

    }, [tubeType, tubeTypeImageMap, selectedStage, thermalTab, boilerType]);



    const [bankType, setBankType] = useState("Single Banking");

    const [tubeBendType, setTubeBendType] = useState("");

    useEffect(() => {
        if (bankType === "Multi Banking") {
            setTubeBendType("2D Bend");
        }
    }, [bankType]);

    const [stub3DBendPosition, setStub3DBendPosition] = useState("-");

    //useEffect(() => {
    //    if (firstLoad) {
    //        /*setImageSrc(require("./Images/Default.png"));*/
    //        setFirstLoad(true);
    //    } else if (bankType && bankTypeImageMap[bankType]) {
    //        setImageSrc(bankTypeImageMap[bankType]);
    //    }
    //}, [bankType, bankTypeImageMap, firstLoad]);


    useEffect(() => {
        //if (selectedStage === "Thermal" && thermalTab === 1) {
        //    /*  Tube tab → always plain*/
        //    setTubeType("Plain");
        //    setImageSrc(require("./Images/Plain_Tube.png"));
        //}

        if (selectedStage === "Thermal" && thermalTab === 2) {

            //setBankType("Single Banking");
            //setTubeBendType("2D Bend");
            // Bank tab → depend on bankType
            if (bankType === "Single Banking") {
                setImageSrc(require("./Images/Banking_Type_Single_Banking.png"));


            } else if (bankType === "Multi Banking") {
                setImageSrc(require("./Images/Banking_Type_Multi_Banking.png"));
            } else {
                setImageSrc(require("./Images/Default.png")); // fallback
            }

            if (tubeBendType === "3D Bend") {
                setImageSrc(require("./Images/Tube_Bend_Type_3D_Bend.png"));

            }

        }
    }, [tubeBendType, bankType, selectedStage, thermalTab]);





    const [finOd, setFinOd] = useState("70.1");
    const [finThk, setFinThk] = useState("1");

    const [finTubePitch, setFinTubePitch] = useState("6.35");
    const [effLen, setEffLen] = useState("8500");



    const [tubeLength, setTubeLength] = useState("0");
    const [wdBank, setWdBank] = useState("");
    const [matComb, setMatComb] = useState("Single");
    const [tubeMat1, setTubeMat1] = useState("SA 192");
    const [tubeMat1Per, setTubeMat1Per] = useState("100");
    const [tubeMat2, setTubeMat2] = useState("SA 192");
    const [tubeMat2Per, setTubeMat2Per] = useState("50");
    const [finMat1, setFinMat1] = useState("SS304");
    const [finMat2, setFinMat2] = useState("SS304");
    const [finType, setFinType] = useState("HELICAL SOLID");


    const [coilLoops, setCoilLoops] = useState([]);

    const [tubesInWidth, setTubesInWidth] = useState("15");
    const [longitudinalPitch, setLongitudinalPitch] = useState("96");
    const [transversePitch, setTransversePitch] = useState("96");
    const [tubesInDeepCommon, setTubesInDeepCommon] = useState("120");

    // Auto-set default values (half of transversePitch) whenever 
    // transversePitch or noOfStart changes
    useEffect(() => {
        const halfPitch = (parseFloat(longitudinalPitch) / 2).toString();
        const count = parseInt(noOfStart1) || 0;

        // Always reset to halfPitch for all coil loops
        const updated = Array(count).fill(halfPitch);
        setCoilLoops(updated);
    }, [longitudinalPitch, noOfStart1]);

    useEffect(() => {
        const eff = parseFloat(effLen) || 0;
        const nStart = parseInt(noOfStart1) || 0;
        const pitch = parseFloat(longitudinalPitch) || 0;

        let bareTubeLen = 0;
        let width = 0;

        if (tubeType === "Plain") {
            width = eff;
        } else if (tubeType === "Finned") {
            bareTubeLen = ((nStart - 1) * pitch) + 50 + (pitch / 2);
            width = eff + (2 * 50) + (2 * bareTubeLen);
        }

        if (!isNaN(width) && width > 0) {
            setWdBank(width.toFixed(2)); // Rounded to 2 decimals
        } else {
            setWdBank("");
        }
    }, [tubeType, effLen, noOfStart1, longitudinalPitch]);


    // Banking Tab
    const [noOfBanks, setNoOfBanks] = useState("0");
    const [tubeInWideArray, setTubeInWideArray] = useState([]);
    const [bankDistanceArray, setBankDistanceArray] = useState([]);
    const [radiusGap, setRadiusGap] = useState("");

    useEffect(() => {
        if (tubeOd === "38.1") {
            setRadiusGap("76");
            setRadiusHeaderGap("76");
            setRadiusHeaderGap_Btm("76");
        } else if (tubeOd === "44.5") {
            setRadiusGap("100");
            setRadiusHeaderGap("100");
            setRadiusHeaderGap_Btm("100");
        } else {
            setRadiusGap(""); // reset if empty
        }
    }, [tubeOd]);

    useEffect(() => {
        if ((selectedStage === "Thermal" && thermalTab === 0) || (selectedStage === "Thermal" && thermalTab === 3) || selectedStage === "Common") {
            setImageSrc(require("./Images/Default.png"));
        }
    }, [selectedStage, thermalTab]);

    useEffect(() => {
        if (selectedStage === "Thermal" && thermalTab === 4) {

            setImageSrc(require("./Images/Casing.png"));
        }
    }, [selectedStage, thermalTab]);

    useEffect(() => {
        if ((selectedStage === "Detailing" && detailingTab === 2) || (selectedStage === "Detailing" && detailingTab === 3)) {
            setImageSrc(require("./Images/Default.png"));
        }
    }, [selectedStage, detailingTab]);

    //Header
    // For Top Header
    const [headerDia, setHeaderDia] = useState("273");
    const [headerThk, setHeaderThk] = useState("25");

    const [headerPosC, setHeaderPosC] = useState("-");
    const [headerLocD, setHeaderLocD] = useState("-");

    const [radiusHeaderGap, setRadiusHeaderGap] = useState("");
    const [headerMat, setHeaderMat] = useState("SA 106 GR B");
    const [typeOfFlow, setTypeOfFlow] = useState("Parallel");

    useEffect(() => {
        // 1. Type Of Flow image (highest priority)
        if (
            boilerType &&
            typeOfFlow &&
            TYPE_OF_FLOW_IMAGES[boilerType]?.[typeOfFlow]
        ) {
            setImageSrc(TYPE_OF_FLOW_IMAGES[boilerType][typeOfFlow]);
            return;
        }

        // 2. Coil Loop / Effective Length / Despatch logic (existing)
        // ... keep your existing priority rules here ...

        //setImageSrc("");
    }, [
        boilerType,
        typeOfFlow,
        TYPE_OF_FLOW_IMAGES,
    ]);


    const [partition, setPartition] = useState("NO");
    const [noOfCount, setNoOfCount] = useState("0");
    const [partitionDistArray_Rows, setPartitionDistArray_Rows] = useState([]);
    const [partitionPlateThk, setPartitionPlateThk] = useState("16");
    const [partitionPlateMat, setPartitionPlateMat] = useState("SA 299");

    //useEffect(() => {
    //    // 1. Header Location Top (highest priority)
    //    if (
    //        headerPosC &&
    //        headerLocD &&
    //        headerLocationTopImageMap[headerPosC]?.[headerLocD]
    //    ) {
    //        setImageSrc(headerLocationTopImageMap[headerPosC][headerLocD]);
    //        return;
    //    }

    //    // 2. Header Position Top (fallback)
    //    if (headerPositionTopImageMap[headerPosC]) {
    //        setImageSrc(headerPositionTopImageMap[headerPosC]);
    //        return;
    //    }

    //    // 3. Fallback
    //    setImageSrc("");
    //}, [
    //    headerPosC,
    //    headerLocD,
    //    headerLocationTopImageMap,
    //    headerPositionTopImageMap,
    //]);




    // For Bottom Header
    const [headerDiaBtm, setHeaderDiaBtm] = useState("273");
    const [headerThkBtm, setHeaderThkBtm] = useState("25");

    const [headerPosCBtm, setHeaderPosCBtm] = useState("-");
    const [headerLocDBtm, setHeaderLocDBtm] = useState("-");

    const [radiusHeaderGap_Btm, setRadiusHeaderGap_Btm] = useState("");
    const [headerMat_Btm, setHeaderMat_Btm] = useState("SA 106 GR B");

    const [partition_Btm, setPartition_Btm] = useState("NO");
    const [noOfCount_Btm, setNoOfCount_Btm] = useState("0");
    const [partitionDistArrayRows_Btm, setPartitionDistArrayRows_Btm] = useState([]);
    const [partitionPlateThk_Btm, setPartitionPlateThk_Btm] = useState("16");
    const [partitionPlateMat_Btm, setPartitionPlateMat_Btm] = useState("SA 299");

    //useEffect(() => {
    //    // 1. Header Location Bottom (highest priority)
    //    if (
    //        headerPosCBtm &&
    //        headerLocDBtm &&
    //        headerLocationBtmImageMap[headerPosCBtm]?.[headerLocDBtm]
    //    ) {
    //        setImageSrc(headerLocationBtmImageMap[headerPosCBtm][headerLocDBtm]);
    //        return;
    //    }

    //    // 2. Header Position Bottom (fallback)
    //    if (headerPositionBtmImageMap[headerPosCBtm]) {
    //        setImageSrc(headerPositionBtmImageMap[headerPosCBtm]);
    //        return;
    //    }

    //    // 3. Fallback
    //    setImageSrc("");
    //}, [
    //    headerPosCBtm,
    //    headerLocDBtm,
    //    headerPositionBtmImageMap,
    //    headerLocationBtmImageMap,
    //]);

    useEffect(() => {
        if (tubeBendType === "3D Bend") {
            setHeaderPosCBtm(headerPosC || "-");
        }
    }, [tubeBendType, headerPosC]);


    //Casing
    const [gapA, setGapA] = useState("0");
    const [gapB, setGapB] = useState("0");
    const [gapC, setGapC] = useState("0");
    const [gapD, setGapD] = useState("0");

    const handleGapAChange = (val) => {
        setGapA(val);
        setGapB(val);

    };

    const handleGapCChange = (val) => {
        setGapC(val);
        setGapD(val);

    };

    //// Thermal Assembly Stage
    const [noOfComponents, setNoOfComponents] = useState("");
    const [compNameArray, setCompNameArray] = useState([]);
    const [compDistanceArray, setCompDistanceArray] = useState([]);




    //// Detailing Stage

    const [componentName_Det, setComponentName_Det] = useState("CWHRB_");
    const [elementId, setElementId] = useState("12400000");

    //Bank
    // Plain Tube Only
    const [clampPlateMat, setClampPlateMat] = useState("SA 516 GR 60");
    const [spacerPlateMat, setSpacerPlateMat] = useState("SA 516 GR 60");

    // Finned Tube Only
    const [supportSleeveOD, setSupportSleeveOD] = useState("0");
    const [supportSleeveThk, setSupportSleeveThk] = useState("0");
    const [supportSleeveLength, setSupportSleeveLength] = useState("0");
    const [supportSleeveMat, setSupportSleeveMat] = useState("SA 106 GR B");
    const [supportRodMat, setSupportRodMat] = useState("SA 105");
    const [supportFlatMat, setSupportFlatMat] = useState("SA 516 GR 60");

    // Common / Others
    const [noOfSupports, setNoOfSupports] = useState("0");
    const [supportPositions, setSupportPositions] = useState(["0"]);
    const [firstSupportFromCoilCL1, setFirstSupportFromCoilCL1] = useState("20");

    useEffect(() => {

        if (noOfSupportsImageMap[noOfSupports]) {
            setImageSrc(noOfSupportsImageMap[noOfSupports]);
            return;
        }

        //setImageSrc("");
    }, [
        noOfSupports,
        noOfSupportsImageMap,

    ]);

    // const [pitchOfSupport, setPitchOfSupport] = useState("90");
    const [halfSleeveReq, setHalfSleeveReq] = useState("NO");
    const [noOfHalfSleeveRows, setNoOfHalfSleeveRows] = useState("3");
    const [halfSleeveMat, setHalfSleeveMat] = useState("SS304 - 2mmThk");

    // Hammering Arrangement

    const [noOfSet, setNoOfSet] = useState("-");
    const [hammerPos, setHammerPos] = useState("30");
    const [hammersSet1, setHammersSet1] = useState("60");
    const [hammersSet2, setHammersSet2] = useState("60");
    const [pitchHammers, setPitchHammers] = useState("90");
    const [hammersFromCoil1, setHammersFromCoil1] = useState("2");
    const [gapHammers, setGapHammers] = useState("45");
    const [hammerSleeveOD, setHammerSleeveOD] = useState("65");
    const [gapBtwHoldingPlt, setGapBtwHoldingPlt] = useState("65");
    const [hammerLevel, sethammerLevel] = useState("90");
    const [hammerSleeveThk, setHammerSleeveThk] = useState("34");
    const [hammerSleeveMat, setHammerSleeveMat] = useState("SA 106 GR B");
    const [holdingPlateMat, setHoldingPlateMat] = useState("SA 516 GR 60");
    const [hammerClampMat, setHammerClampMat] = useState("SA 516 GR 60");



    useEffect(() => {
        if (selectedStage === "Common") {
            setImageSrc(require("./Images/Default.png"));
            return;
        }

        if (selectedStage === "Detailing" && detailingTab === 1) {

            setImageSrc(require("./Images/No_of_Set_1.png"));
        }

    }, [selectedStage, detailingTab]);

    useEffect(() => {
        if (noOfSetImageMap[noOfSet]) {
            setImageSrc(noOfSetImageMap[noOfSet]);
        }
    }, [noOfSet, noOfSetImageMap]);

    useEffect(() => {
        if (
            hammeringPosImageMap[noOfSet] &&
            hammeringPosImageMap[noOfSet][hammerPos]
        ) {
            setImageSrc(hammeringPosImageMap[noOfSet][hammerPos]);
        }
    }, [noOfSet, hammerPos, hammeringPosImageMap]);


    //Process inputs
    const [coilMaxP, setCoilMaxP] = useState("20");
    const [coilMaxT, setCoilMaxT] = useState("20");
    const [coilWorkT, setCoilWorkT] = useState("20");

    const [inletMaxP, setInletMaxP] = useState("20");
    const [inletMaxT, setInletMaxT] = useState("20");
    const [inletWorkT, setInletWorkT] = useState("20");

    const [outletMaxP, setOutletMaxP] = useState("20");
    const [outletMaxT, setOutletMaxT] = useState("20");
    const [outletWorkT, setOutletWorkT] = useState("20");

    const [flueEntryT, setFlueEntryT] = useState("20");
    const [flueExitT, setFlueExitT] = useState("20");


    //Header

    //// Top Header

    // const [headerPosC_Det, setHeaderPosC_Det] = useState("-");

    const [headerLocD_Det, setHeaderLocD_Det] = useState("-");
    //const [headerStubVariant, setHeaderStubVariant] = useState("Short");
    const [heightFromCoil, setHeightFromCoil] = useState("3456");
    const [distanceFromCasingID, setDistanceFromCasingID] = useState("567");

    const [headerStubs, setHeaderStubs] = useState(
        Array.from({ length: parseInt(noOfStart1) }, () => ({
            type: "",
            angle: "0",
            weldPos: "0",
            distance: "0",
            dist_Pt: "0"
        }))
    );

    // Update header stubs whenever noOfStart1 changes
    useEffect(() => {
        setHeaderStubs(
            Array.from({ length: parseInt(noOfStart1) || 0 }, () => ({
                type: "",
                angle: "0",
                weldPos: "0",
                distance: "0",
                dist_Pt: "0",
            }))
        );
    }, [noOfStart1]);

    const [headerEndDistD1, setHeaderEndDistD1] = useState("300");
    const [headerEndDistD2, setHeaderEndDistD2] = useState("300");
    const [headerConnection, setHeaderConnection] = useState("");
    const [fieldWeldBetweenHeader, setFieldWeldBetweenHeader] = useState("NO");
    const [noOfFieldWeld, setNoOfFieldWeld] = useState("0");
    const [fieldWeldLoc1, setFieldWeldLoc1] = useState("0");
    const [fieldWeldLoc2, setFieldWeldLoc2] = useState("0");
    const [fieldWeldLoc3, setFieldWeldLoc3] = useState("0");

    const [sealPadRequired, setSealPadRequired] = useState("NO");
    const [sealPadWidth, setSealPadWidth] = useState("0");
    const [sealPadThick, setSealPadThick] = useState("0");
    const [sealPadMaterial, setSealPadMaterial] = useState("SA 106 GR B");
    const [sealPadDistance, setSealPadDistance] = useState("0");
    const [sealPadDistance1, setSealPadDistance1] = useState("0");
    useEffect(() => {
        setSealPadDistance(gapC);
        setSealPadDistance1(gapC);

    }, [gapC]);
    const [endPlatePosition, setEndPlatePosition] = useState("Left");
    const [endPlateThk, setEndPlateThk] = useState("0");
    const [endPlateMaterial, setEndPlateMaterial] = useState("SA 516 GR 60");


    const [inspectionNozzle, setInspectionNozzle] = useState("NO");
    const [inspectionNozzlePosition, setInspectionNozzlePosition] = useState("Left");
    const [inspectionNozzleOD, setInspectionNozzleOD] = useState("0");
    const [inspectionNozzleThk, setInspectionNozzleThk] = useState("0");
    const [inspectionNozzleMaterial, setInspectionNozzleMaterial] = useState("SA 106 GR B");

    const [bafflePadRequired, setBafflePadRequired] = useState("NO");
    const [bafflePadWidth, setBafflePadWidth] = useState("0");
    const [bafflePadThick, setBafflePadThick] = useState("0");
    const [bafflePadMaterial, setBafflePadMaterial] = useState("SA 516 GR 60");
    const [bafflePadOrientation, setBafflePadOrientation] = useState("0");
    const [bafflePadLength, setBafflePadLength] = useState("0");

    useEffect(() => {
        // Convert to numbers to avoid string concatenation
        const D1 = parseFloat(headerEndDistD1) || 0;
        const D2 = parseFloat(headerEndDistD2) || 0;
        const pitch = parseFloat(longitudinalPitch) || 0;
        const tubes = parseFloat(tubesInDeepCommon) || 0;
        const gap = parseFloat(gapC) || 0;

        const HeaderLength = D1 + D2 + pitch * (tubes - 1);
        const Casing = pitch * (tubes - 1) + (gap * 2);


        let value = 0;
        if (HeaderLength > Casing) {
            value = Casing - 20;
        } else {
            value = HeaderLength - 40;
        }

        setBafflePadLength(value);
    }, [headerEndDistD1, headerEndDistD2, longitudinalPitch, tubesInDeepCommon, gapC]);


    const [expPadRequired, setExpPadRequired] = useState("NO");
    const [expPadLocation, setExpPadLocation] = useState("-");
    const [expPadLocNew, setExpPadLocNew] = useState("0");

    const [expPadLength, setExpPadLength] = useState("0");
    const [expPadThk, setExpPadThk] = useState("0");
    const [expPadMaterial, setExpPadMaterial] = useState("SA 516 GR 60");

    //const [noOfBranch, setNoOfBranch] = useState("");
    const [branchDistanceArray, setBranchDistanceArray] = useState([]);
    const [branchType, setBranchType] = useState("-");
    const [branchLength, setBranchLength] = useState("0");
    const [branchDistanceX, setBranchDistanceX] = useState("0");
    const [branchDistanceY, setBranchDistanceY] = useState("0");
    const [branchRadius, setBranchRadius] = useState("0");
    const [branchAngle, setBranchAngle] = useState("0");
    const [branchOD, setBranchOD] = useState("0");
    const [branchThk, setBranchThk] = useState("0");
    const [branchMaterial, setBranchMaterial] = useState("SA 106 GR B");

    // ✅ useState hooks for Branch Pad
    const [branchPadRequired, setBranchPadRequired] = useState("NO");
    const [branchPadWidth, setBranchPadWidth] = useState("0");
    const [branchPadThk, setBranchPadThk] = useState("0");
    const [branchPadMaterial, setBranchPadMaterial] = useState("SA 106 GR B");
    const [branchPadDistance, setBranchPadDistance] = useState("0");

    const [connectingPipeSize, setConnectingPipeSize] = useState("0");
    const [connectingPipeThk, setConnectingPipeThk] = useState("0");
    const [connectingPipeSize_Head_End, setConnectingPipeSize_Head_End] = useState("0");
    const [connectingPipeThk_Head_End, setConnectingPipeThk_Head_End] = useState("0");
    const [ventNozzleReq, setVentNozzleReq] = useState("NO");
    const [ventNozzlePosition, setVentNozzlePosition] = useState("Left");
    const [ventNozzleLocation, setVentNozzleLocation] = useState("0");
    const [ventNozzleOD, setVentNozzleOD] = useState("0");
    const [ventNozzleThk, setVentNozzleThk] = useState("0");
    const [ventNozzleMaterial, setVentNozzleMaterial] = useState("SA 192");
    const [ventNozzleLength, setVentNozzleLength] = useState("0");
    const [connectingPipeSizeVent, setConnectingPipeSizeVent] = useState("0");
    const [connectingPipeThkVent, setConnectingPipeThkVent] = useState("0");
    /*const [focusedStubIndex, setFocusedStubIndex] = useState(null);*/



    useEffect(() => {
        // 1. Header Stub angle (highest priority if a stub is focused)

        // 2. Branch Type TOP
        if (branchType && headerPosC && branchTypeTopImageMap[branchType]?.[headerPosC]) {
            setImageSrc(branchTypeTopImageMap[branchType][headerPosC]);
            return;
        }

        // 3. Header Location DETAIL TOP
        if (headerPosC && headerLocD_Det && headerLocationDetTopImageMap[headerPosC]?.[headerLocD_Det]) {
            setImageSrc(headerLocationDetTopImageMap[headerPosC][headerLocD_Det]);
            return;
        }

        // 4. Header Location TOP
        if (headerPosC && headerLocD && headerLocationTopImageMap[headerPosC]?.[headerLocD]) {
            setImageSrc(headerLocationTopImageMap[headerPosC][headerLocD]);
            return;
        }

        // 5. Header Position TOP
        if (headerPositionTopImageMap[headerPosC]) {
            setImageSrc(headerPositionTopImageMap[headerPosC]);
            return;
        }

        // 6. Clear fallback
        //setImageSrc("");
    }, [

        headerPosC,
        branchType,
        headerLocD,
        headerLocD_Det,
        branchTypeTopImageMap,
        headerLocationDetTopImageMap,
        headerLocationTopImageMap,
        headerPositionTopImageMap,
    ]);

    const updateStubAngleImage = (index) => {
        if (!headerPosC) {
            /*setImageSrc("");*/
            return;
        }

        const isStub1 = index === 0;
        const groupKey = isStub1 ? "STUB1" : "STUB2_5";

        const img =
            HEADER_STUB_ANGLE_TOP_IMAGES[groupKey]?.[headerPosC];

        setImageSrc(img || "");
    };



    const getStubEndPointImage = (headerPosC, stubType) => {
        if (!headerPosC || !stubType) return null;
        return STUB_END_POINT_IMAGES[headerPosC]?.[stubType] || null;
    };

    const getStubEndPointBtmImage = (headerPosC, stubType) => {
        if (!headerPosC || !stubType) return null;
        return STUB_END_POINT_BTM_IMAGES[headerPosC]?.[stubType] || null;
    };



    //useEffect(() => {
    //    if (focusedStubIndex === null) return;
    //    if (headerPosC !== "LHS" && headerPosC !== "RHS") return;

    //    // 🔹 STUB–1
    //    if (focusedStubIndex === 0) {
    //        if (headerPosC === "LHS") {
    //            setImageSrc(
    //                require("./Images/Header_Stub1_Angle_LHS_Top.png")
    //            );
    //            return;
    //        }

    //        if (headerPosC === "RHS") {
    //            setImageSrc(
    //                require("./Images/Header_Stub1_Angle_RHS_Top.png")
    //            );
    //            return;
    //        }
    //    }

    //    // 🔹 STUB–2 to STUB–5
    //    if (focusedStubIndex > 0) {
    //        if (headerPosC === "LHS") {
    //            setImageSrc(
    //                require("./Images/Header_Stub_Angle_LHS_Top2_5.png")
    //            );
    //            return;
    //        }

    //        if (headerPosC === "RHS") {
    //            setImageSrc(
    //                require("./Images/Header_Stub_Angle_RHS_Top2_5.png")
    //            );
    //            return;
    //        }
    //    }
    //}, [focusedStubIndex, headerPosC]);




    useEffect(() => {
        if (HEADER_CONNECTION_IMAGE_MAP[headerConnection]) {
            setImageSrc(HEADER_CONNECTION_IMAGE_MAP[headerConnection]);
        } else {
            //setImageSrc("");
        }
    }, [headerConnection, HEADER_CONNECTION_IMAGE_MAP]);


    useEffect(() => {
        if (noOfFieldWeldImageMap[noOfFieldWeld]) {
            setImageSrc(noOfFieldWeldImageMap[noOfFieldWeld]);
        } else {
            //setImageSrc("");
        }
    }, [noOfFieldWeld, noOfFieldWeldImageMap]);

    useEffect(() => {
        if (expPadLocationBtmImageMap[expPadLocation]) {
            setImageSrc(expPadLocationBtmImageMap[expPadLocation]);
        } else {
            //setImageSrc("");
        }
    }, [expPadLocation, expPadLocationBtmImageMap]);




    //// Bottom Header

    //const [headerPosC_Det_Btm, setHeaderPosC_Det_Btm] = useState("LHS");
    const [headerLocD_Det_Btm, setHeaderLocD_Det_Btm] = useState("-");
    //const [headerStubVariant_Btm, setHeaderStubVariant_Btm] = useState("Short");
    const [heightFromCoil_Btm, setHeightFromCoil_Btm] = useState("0");
    const [distanceFromCasingID_Btm, setDistanceFromCasingID_Btm] = useState("0");

    // ✅ Initialize Header Stubs for Bottom Header
    const [headerStubs_Btm, setHeaderStubs_Btm] = useState(
        Array.from({ length: parseInt(noOfStart1) }, () => ({
            type: "",
            angle: "0",
            weldPos: "0",
            distance: "0",
            dist_Pt: "0"
        }))
    );

    // ✅ Update Header Stubs whenever noOfStart1 changes
    useEffect(() => {
        setHeaderStubs_Btm(
            Array.from({ length: parseInt(noOfStart1) || 0 }, () => ({
                type: "",
                angle: "0",
                weldPos: "0",
                distance: "0",
                dist_Pt: "0"
            }))
        );
    }, [noOfStart1]);



    const [headerEndDistD1_Btm, setHeaderEndDistD1_Btm] = useState("0");
    const [headerEndDistD2_Btm, setHeaderEndDistD2_Btm] = useState("0");
    const [headerConnection_Btm, setHeaderConnection_Btm] = useState("");
    const [fieldWeldBetweenHeader_Btm, setFieldWeldBetweenHeader_Btm] = useState("NO");
    const [noOfFieldWeld_Btm, setNoOfFieldWeld_Btm] = useState("0");
    const [fieldWeldLoc1_Btm, setFieldWeldLoc1_Btm] = useState("0");
    const [fieldWeldLoc2_Btm, setFieldWeldLoc2_Btm] = useState("0");
    const [fieldWeldLoc3_Btm, setFieldWeldLoc3_Btm] = useState("0");

    const [sealPadRequired_Btm, setSealPadRequired_Btm] = useState("NO");
    const [sealPadWidth_Btm, setSealPadWidth_Btm] = useState("0");
    const [sealPadThick_Btm, setSealPadThick_Btm] = useState("0");
    const [sealPadMaterial_Btm, setSealPadMaterial_Btm] = useState("SA 106 GR B");
    const [sealPadDistance_Btm, setSealPadDistance_Btm] = useState("0");
    const [sealPadDistance_Btm1, setSealPadDistance_Btm1] = useState("0");
    useEffect(() => {
        setSealPadDistance_Btm(gapC);
        setSealPadDistance_Btm1(gapC);
    }, [gapC]);
    const [endPlatePosition_Btm, setEndPlatePosition_Btm] = useState("Left");
    const [endPlateThk_Btm, setEndPlateThk_Btm] = useState("0");
    const [endPlateMaterial_Btm, setEndPlateMaterial_Btm] = useState("SA 516 GR 60");

    const [inspectionNozzlePosition_Btm, setInspectionNozzlePosition_Btm] = useState("Left");
    const [inspectionNozzle_Btm, setInspectionNozzle_Btm] = useState("NO");
    const [inspectionNozzleOD_Btm, setInspectionNozzleOD_Btm] = useState("0");
    const [inspectionNozzleThk_Btm, setInspectionNozzleThk_Btm] = useState("0");
    const [inspectionNozzleMaterial_Btm, setInspectionNozzleMaterial_Btm] = useState("SA 106 GR B");

    const [bafflePadRequired_Btm, setBafflePadRequired_Btm] = useState("NO");
    const [bafflePadWidth_Btm, setBafflePadWidth_Btm] = useState("0");
    const [bafflePadThk_Btm, setBafflePadThk_Btm] = useState("0");
    const [bafflePadMaterial_Btm, setBafflePadMaterial_Btm] = useState("SA 516 GR 60");
    const [bafflePadOrientation_Btm, setBafflePadOrientation_Btm] = useState("0");
    const [bafflePadLength_Btm, setBafflePadLength_Btm] = useState("0");

    useEffect(() => {
        const D1_Btm = parseFloat(headerEndDistD1_Btm) || 0;
        const D2_Btm = parseFloat(headerEndDistD2_Btm) || 0;
        const pitch = parseFloat(longitudinalPitch) || 0;
        const tubes = parseFloat(tubesInDeepCommon) || 0;
        const gap = parseFloat(gapC) || 0;

        const HeaderLength_Btm = D1_Btm + D2_Btm + pitch * (tubes - 1);
        const Casing_Btm = pitch * (tubes - 1) + (gap * 2);

        const value_Btm = HeaderLength_Btm > Casing_Btm ? Casing_Btm - 20 : HeaderLength_Btm - 40;
        setBafflePadLength_Btm(value_Btm);
    }, [headerEndDistD1_Btm, headerEndDistD2_Btm, longitudinalPitch, tubesInDeepCommon, gapC]);

    const [expPadRequired_Btm, setExpPadRequired_Btm] = useState("NO");
    const [expPadLocation_Btm, setExpPadLocation_Btm] = useState("-");
    const [expPadLocNew_Btm, setExpPadLocNew_Btm] = useState("0");
    const [expPadLength_Btm, setExpPadLength_Btm] = useState("0");
    const [expPadThk_Btm, setExpPadThk_Btm] = useState("0");
    const [expPadMaterial_Btm, setExpPadMaterial_Btm] = useState("SA 516 GR 60");

    //const [noOfBranch_Btm, setNoOfBranch_Btm] = useState("");
    const [branchDistanceArray_Btm, setBranchDistanceArray_Btm] = useState([]);
    const [branchType_Btm, setBranchType_Btm] = useState("-");
    const [branchLength_Btm, setBranchLength_Btm] = useState("0");
    const [branchDistanceX_Btm, setBranchDistanceX_Btm] = useState("0");
    const [branchDistanceY_Btm, setBranchDistanceY_Btm] = useState("0");
    const [branchRadius_Btm, setBranchRadius_Btm] = useState("0");
    const [branchAngle_Btm, setBranchAngle_Btm] = useState("0");
    const [branchOD_Btm, setBranchOD_Btm] = useState("0");
    const [branchThk_Btm, setBranchThk_Btm] = useState("0");
    const [branchMaterial_Btm, setBranchMaterial_Btm] = useState("SA 106 GR B");

    const [branchPadRequired_Btm, setBranchPadRequired_Btm] = useState("NO");
    const [branchPadWidth_Btm, setBranchPadWidth_Btm] = useState("0");
    const [branchPadThk_Btm, setBranchPadThk_Btm] = useState("0");
    const [branchPadMaterial_Btm, setBranchPadMaterial_Btm] = useState("SA 106 GR B");
    const [branchPadDistance_Btm, setBranchPadDistance_Btm] = useState("0");

    const [connectingPipeSize_Btm, setConnectingPipeSize_Btm] = useState("0");
    const [connectingPipeThk_Btm, setConnectingPipeThk_Btm] = useState("0");
    const [connectingPipeSize_Btm_Head_End, setConnectingPipeSize_Btm_Head_End] = useState("0");
    const [connectingPipeThk_Btm_Head_End, setConnectingPipeThk_Btm_Head_End] = useState("0");

    const [drainNozzleReq_Btm, setDrainNozzleReq_Btm] = useState("NO");
    const [drainNozzlePosition_Btm, setDrainNozzlePosition_Btm] = useState("Left");
    const [drainNozzleLocation_Btm, setDrainNozzleLocation_Btm] = useState("0");
    const [drainNozzleOD_Btm, setDrainNozzleOD_Btm] = useState("0");
    const [drainNozzleThk_Btm, setDrainNozzleThk_Btm] = useState("0");
    const [drainNozzleMaterial_Btm, setDrainNozzleMaterial_Btm] = useState("SA 192");
    const [drainNozzleLength_Btm, setDrainNozzleLength_Btm] = useState("0");
    const [connectingPipeSizeDrain_Btm, setConnectingPipeSizeDrain_Btm] = useState("0");
    const [connectingPipeThkDrain_Btm, setConnectingPipeThkDrain_Btm] = useState("0");

    useEffect(() => {

        // 1. Branch Type BOTTOM (OVERRIDES header location)
        if (
            branchType_Btm &&
            headerPosCBtm &&
            branchTypeBtmImageMap[branchType_Btm]?.[headerPosCBtm]
        ) {
            setImageSrc(
                branchTypeBtmImageMap[branchType_Btm][headerPosCBtm]
            );
            return;
        }

        // 2. Header Location DETAIL BOTTOM
        if (
            headerPosCBtm &&
            headerLocD_Det_Btm &&
            headerLocationDetBtmImageMap[headerPosCBtm]?.[headerLocD_Det_Btm]
        ) {
            setImageSrc(
                headerLocationDetBtmImageMap[headerPosCBtm][headerLocD_Det_Btm]
            );
            return;
        }

        // 3. Header Location BOTTOM
        if (
            headerPosCBtm &&
            headerLocDBtm &&
            headerLocationBtmImageMap[headerPosCBtm]?.[headerLocDBtm]
        ) {
            setImageSrc(
                headerLocationBtmImageMap[headerPosCBtm][headerLocDBtm]
            );
            return;
        }

        // 4. Header Position BOTTOM
        if (headerPositionBtmImageMap[headerPosCBtm]) {
            setImageSrc(headerPositionBtmImageMap[headerPosCBtm]);
            return;
        }

        // 5. Clear
        //setImageSrc("");

    }, [

        // Branch selector
        branchType_Btm,
        headerPosCBtm,

        // Header-related
        headerLocDBtm,
        headerLocD_Det_Btm,

        // Maps
        headerLocationDetBtmImageMap,
        branchTypeBtmImageMap,
        headerLocationBtmImageMap,
        headerPositionBtmImageMap,
    ]);

    const updateStubAngleImage_Btm = (index) => {
        if (!headerPosCBtm) {
            //setImageSrc("");
            return;
        }

        const isStub1 = index === 0;
        const groupKey = isStub1 ? "STUB1" : "STUB2_5";

        const img =
            HEADER_STUB_ANGLE_BOTTOM_IMAGES[groupKey]?.[headerPosCBtm];

        setImageSrc(img || "");
    };


    useEffect(() => {
        if (HEADER_CONNECTION_IMAGE_MAP[headerConnection_Btm]) {
            setImageSrc(HEADER_CONNECTION_IMAGE_MAP[headerConnection_Btm]);
        } else {
            //setImageSrc("");
        }
    }, [headerConnection_Btm, HEADER_CONNECTION_IMAGE_MAP]);

    useEffect(() => {
        if (noOfFieldWeldImageMap[noOfFieldWeld_Btm]) {
            setImageSrc(noOfFieldWeldImageMap[noOfFieldWeld_Btm]);
        } else {
            //setImageSrc("");
        }
    }, [noOfFieldWeld_Btm, noOfFieldWeldImageMap]);

    useEffect(() => {
        if (expPadLocationBtmImageMap[expPadLocation_Btm]) {
            setImageSrc(expPadLocationBtmImageMap[expPadLocation_Btm]);
        } else {
            //setImageSrc("");
        }
    }, [expPadLocation_Btm, expPadLocationBtmImageMap]);




    //GA Assembly

    const [noOfComponentsDet, setNoOfComponentsDet] = useState("");
    const [compNameArrayDet, setCompNameArrayDet] = useState([]);
    const [compDistanceArrayDet, setCompDistanceArrayDet] = useState([]);
    const [componentMode, setComponentMode] = useState("Individual");
    const [componentName_Ind, setComponentName_Ind] = useState("");
    const [tieMember_Req, setTieMember_Req] = useState("NO");
    const [tieMemberToCoilDist, setTieMemberToCoilDist] = useState("0");
    const [lug_Req, setLug_Req] = useState("YES");

    //const [tieMemberReqArr, setTieMemberReqArr] = useState([]);
    //const [tieMemberDistArr, setTieMemberDistArr] = useState([]);
    //const [lugReqArr, setLugReqArr] = useState([]);

    const [assemblyDwgNo, setAssemblyDwgNo] = useState("");
    const [fabricationDwgNo, setFabricationDwgNo] = useState("");
    const [headerDwgNo, setHeaderDwgNo] = useState("");
    const [fabBomItemCode, setFabBomItemCode] = useState("");
    const [headerBomItemCode, setHeaderBomItemCode] = useState("");


    const showSnack = (message, severity = "success") => {
        setSnack({ open: true, message, severity });
    };

    useEffect(() => {
        const pingAgent = async () => {
            try {
                const res = await fetch(`${baseUrl}/status-inventor`);
                if (!res.ok) throw new Error("Status check failed");
                setAgentStatus("✅ Application is active.");
            } catch (error) {
                setShowInstallMsg(true);
                setAgentStatus("❌ Application not detected.");
                console.error("Backend not reachable:", error);
            }
        };
        pingAgent();
    }, []);

    const handleAsync = async (fn) => {
        setLoading(true);
        try {
            await fn();
        } catch (error) {
            console.error("Request failed:", error);
            showSnack("❌ Failed to connect to backend.", "error");
        } finally {
            setLoading(false);
        }
    };


    const executeThermal = (tab) => {
        let parameters = {};

        if (tab === "Casing") {
            parameters = {
                casingStage: {
                    ProjectId: projectId,
                    Title: title,
                    Capacity: parseFloat(capacity),
                    Standard: standard,
                    BoilerType: boilerType,
                    Group: group,
                    Department: department,
                    IWT: iwt,


                    ComponentName_Thr: componentName_Thr,
                    ComponentName: componentName,
                    Pressure: pressure,
                    Name1: name1,
                    CompNo: compNo,
                    NoOfStart1: parseFloat(noOfStart1),
                    Despatch: despatch,
                    DrawingNo: drawingNo,

                    TubeOD: parseFloat(tubeOd),
                    TubeThk: parseFloat(tubeThk),
                    TubeType: tubeType,
                    BankType: bankType,

                    FinOD: parseFloat(finOd),
                    FinThk: parseFloat(finThk),
                    FinTubePitch: parseFloat(finTubePitch),
                    EffLen: parseFloat(effLen),
                    TubeLength: parseFloat(tubeLength),
                    WdBank: parseFloat(wdBank),
                    MatComb: matComb,
                    TubeMat1: tubeMat1,
                    TubeMat1Per: parseFloat(tubeMat1Per),
                    TubeMat2: tubeMat2,
                    TubeMat2Per: parseFloat(tubeMat2Per),
                    FinMat1: finMat1,
                    FinMat2: finMat2,
                    FinType: finType,
                    CoilLoops: coilLoops.map(val => parseFloat(val)),

                    LongitudinalPitch: parseFloat(longitudinalPitch),
                    TransversePitch: parseFloat(transversePitch),
                    TubesInDeepCommon: parseInt(tubesInDeepCommon),

                    NoOfBanks: parseInt(noOfBanks),
                    TubeBendType: tubeBendType,
                    Stub3DBendPosition: stub3DBendPosition,
                    TubesInWidth: parseInt(tubesInWidth),
                    TubeInWideArray: tubeInWideArray.map(val => parseFloat(val)),
                    BankDistanceArray: bankDistanceArray.map(val => parseFloat(val)),
                    BankRadiusGap: parseFloat(radiusGap),

                    // Top Header
                    HeaderDia: parseFloat(headerDia),
                    HeaderThk: parseFloat(headerThk),
                    HeaderPosC: headerPosC,
                    HeaderLocD: headerLocD,
                    RadiusHeaderGap: parseFloat(radiusHeaderGap),
                    HeaderMat: headerMat,
                    TypeOfFlow: typeOfFlow,
                    Partition: partition,
                    NoOfCount: noOfCount,
                    PartitionPlateThk: parseFloat(partitionPlateThk),
                    PartitionPlateMat: partitionPlateMat,
                    PartitionDistArray_Rows: partitionDistArray_Rows.map(val => parseFloat(val)),

                    // Bottom Header
                    HeaderDiaBtm: parseFloat(headerDiaBtm),
                    HeaderThkBtm: parseFloat(headerThkBtm),
                    HeaderPosCBtm: headerPosCBtm,
                    HeaderLocDBtm: headerLocDBtm,
                    RadiusHeaderGap_Btm: parseFloat(radiusHeaderGap_Btm),
                    HeaderMat_Btm: headerMat_Btm,

                    Partition_Btm: partition_Btm,
                    NoOfCount_Btm: noOfCount_Btm,
                    PartitionPlateThk_Btm: parseFloat(partitionPlateThk_Btm),
                    PartitionPlateMat_Btm: partitionPlateMat_Btm,
                    PartitionDistArrayRows_Btm: partitionDistArrayRows_Btm.map(val => parseFloat(val)),

                    // Casing
                    GapA: parseFloat(gapA),
                    GapB: parseFloat(gapB),
                    GapC: parseFloat(gapC),
                    GapD: parseFloat(gapD),

                }
            };

            drawShape(
                "execute-Casing",
                parameters,
                "✅ Casing Execution completed successfully!"
            );
        }

        if (tab === "Thermal Assembly") {
            parameters = {
                thermalAssemblyStage: {
                    // 👉 only thermal assembly inputs
                    No_Of_Components: noOfComponents,
                    Comp_Name_Array: compNameArray.map(val => val),
                    Comp_Distance_Array: compDistanceArray.map(val => parseFloat(val)),
                }
            };

            drawShape(
                "execute-ThermalAssembly",
                parameters,
                "✅ Thermal Assembly Execution completed successfully!"
            );
        }
    };

    const executeDetailing = (tab) => {

        let parameters = {};

        if (tab === "Header") {

            const headerStubInputs = headerStubs.map(stub => ({
                Type: stub.type,
                Angle: parseFloat(stub.angle),
                WeldPos: parseFloat(stub.weldPos),
                Distance: parseFloat(stub.distance),
                Dist_Pt: parseFloat(stub.dist_Pt)
            }));

            const headerStubInputs_Btm = headerStubs_Btm.map(stub => ({
                Type: stub.type,
                Angle: parseFloat(stub.angle),
                WeldPos: parseFloat(stub.weldPos),
                Distance: parseFloat(stub.distance),
                Dist_Pt: parseFloat(stub.dist_Pt)
            }));

            parameters = {
                detailingStage: {

                    ComponentName_Det: componentName_Det,
                    ElementId: parseFloat(elementId),

                    // --- Bank Section ---
                    // Plain Tube Only
                    ClampPlateMat: clampPlateMat,
                    SpacerPlateMat: spacerPlateMat,

                    // Finned Tube Only
                    SupportSleeveOD: parseFloat(supportSleeveOD),
                    SupportSleeveThk: parseFloat(supportSleeveThk),
                    SupportSleeveLength: parseFloat(supportSleeveLength),
                    SupportSleeveMat: supportSleeveMat,
                    SupportRodMat: supportRodMat,
                    SupportFlatMat: supportFlatMat,

                    // Common / Others
                    NoOfSupports: parseInt(noOfSupports),
                    SupportPositions: supportPositions.map(val => parseFloat(val)),
                    FirstSupportFromCoilCL1: parseFloat(firstSupportFromCoilCL1),
                    // PitchOfSupport: parseFloat(pitchOfSupport),
                    HalfSleeveReq: halfSleeveReq,
                    NoOfHalfSleeveRows: parseInt(noOfHalfSleeveRows),
                    HalfSleeveMat: halfSleeveMat,

                    // --- Hammering Arrangement ---
                    NoOfSet: noOfSet,
                    HammerPos: hammerPos,
                    HammersSet1: parseFloat(hammersSet1),
                    HammersSet2: parseFloat(hammersSet2),
                    PitchHammers: parseFloat(pitchHammers),
                    HammersFromCoil1: parseFloat(hammersFromCoil1),
                    GapHammers: parseFloat(gapHammers),
                    HammerSleeveOD: parseFloat(hammerSleeveOD),
                    GapBtwHoldingPlt: parseFloat(gapBtwHoldingPlt),
                    HammerLevel: parseFloat(hammerLevel),
                    HammerSleeveThk: parseFloat(hammerSleeveThk),
                    HammerSleeveMat: hammerSleeveMat,
                    HoldingPlateMat: holdingPlateMat,
                    HammerClampMat: hammerClampMat,

                    // --- Process Inputs ---
                    CoilMaxP: parseFloat(coilMaxP),
                    CoilMaxT: parseFloat(coilMaxT),
                    CoilWorkT: parseFloat(coilWorkT),

                    InletMaxP: parseFloat(inletMaxP),
                    InletMaxT: parseFloat(inletMaxT),
                    InletWorkT: parseFloat(inletWorkT),

                    OutletMaxP: parseFloat(outletMaxP),
                    OutletMaxT: parseFloat(outletMaxT),
                    OutletWorkT: parseFloat(outletWorkT),

                    FlueEntryT: parseFloat(flueEntryT),
                    FlueExitT: parseFloat(flueExitT),

                    // --- Top Header ---
                    //HeaderPosC_Det: headerPosC_Det,
                    HeaderLocD_Det: headerLocD_Det,
                    //HeaderStubVariant: headerStubVariant,
                    HeightFromCoil: parseFloat(heightFromCoil),
                    DistanceFromCasingID: parseFloat(distanceFromCasingID),




                    HeaderEndDistD1: parseFloat(headerEndDistD1),
                    HeaderEndDistD2: parseFloat(headerEndDistD2),
                    HeaderConnection: headerConnection,
                    FieldWeldBetweenHeader: fieldWeldBetweenHeader,
                    NoOfFieldWeld: parseInt(noOfFieldWeld),
                    FieldWeldLoc1: parseFloat(fieldWeldLoc1),
                    FieldWeldLoc2: parseFloat(fieldWeldLoc2),
                    FieldWeldLoc3: parseFloat(fieldWeldLoc3),

                    SealPadRequired: sealPadRequired,
                    SealPadWidth: parseFloat(sealPadWidth),
                    SealPadThick: parseFloat(sealPadThick),
                    SealPadMaterial: sealPadMaterial,
                    SealPadDistance: parseFloat(sealPadDistance),
                    SealPadDistance1: parseFloat(sealPadDistance1),
                    EndPlatePosition: endPlatePosition,
                    EndPlateThk: parseFloat(endPlateThk),
                    EndPlateMaterial: endPlateMaterial,


                    InspectionNozzle: inspectionNozzle,
                    InspectionNozzlePosition: inspectionNozzlePosition,
                    InspectionNozzleOD: parseFloat(inspectionNozzleOD),
                    InspectionNozzleThk: parseFloat(inspectionNozzleThk),
                    InspectionNozzleMaterial: inspectionNozzleMaterial,

                    BafflePadRequired: bafflePadRequired,
                    BafflePadWidth: parseFloat(bafflePadWidth),
                    BafflePadThick: parseFloat(bafflePadThick),
                    BafflePadMaterial: bafflePadMaterial,
                    BafflePadOrientation: parseFloat(bafflePadOrientation),
                    BafflePadLength: parseFloat(bafflePadLength),

                    ExpPadRequired: expPadRequired,
                    ExpPadLocation: expPadLocation,
                    ExpPadLocNew: parseFloat(expPadLocNew),
                    ExpPadLength: parseFloat(expPadLength),
                    ExpPadThk: parseFloat(expPadThk),
                    ExpPadMaterial: expPadMaterial,

                    //NoOfBranch: parseInt(noOfBranch),
                    BranchDistanceArray: branchDistanceArray.map(val => parseFloat(val)),
                    BranchType: branchType,
                    BranchLength: parseFloat(branchLength),
                    BranchDistanceX: parseFloat(branchDistanceX),
                    BranchDistanceY: parseFloat(branchDistanceY),
                    BranchRadius: parseFloat(branchRadius),
                    BranchAngle: parseFloat(branchAngle),
                    BranchOD: parseFloat(branchOD),
                    BranchThk: parseFloat(branchThk),
                    BranchMaterial: branchMaterial,

                    BranchPadRequired: branchPadRequired,
                    BranchPadWidth: parseFloat(branchPadWidth),
                    BranchPadThk: parseFloat(branchPadThk),
                    BranchPadMaterial: branchPadMaterial,
                    BranchPadDistance: parseFloat(branchPadDistance),

                    ConnectingPipeSize: parseFloat(connectingPipeSize),
                    ConnectingPipeThk: parseFloat(connectingPipeThk),
                    ConnectingPipeSize_Head_End: parseFloat(connectingPipeSize_Head_End),
                    ConnectingPipeThk_Head_End: parseFloat(connectingPipeThk_Head_End),
                    VentNozzleReq: ventNozzleReq,
                    VentNozzlePosition: ventNozzlePosition,
                    VentNozzleLocation: parseFloat(ventNozzleLocation),
                    VentNozzleOD: parseFloat(ventNozzleOD),
                    VentNozzleThk: parseFloat(ventNozzleThk),
                    VentNozzleMaterial: ventNozzleMaterial,
                    VentNozzleLength: parseFloat(ventNozzleLength),
                    ConnectingPipeSizeVent: parseFloat(connectingPipeSizeVent),
                    ConnectingPipeThkVent: parseFloat(connectingPipeThkVent),
                    HeaderStubs: headerStubInputs,

                    // --- Bottom Header ---
                    /* HeaderPosC_Det_Btm: headerPosC_Det_Btm,*/
                    HeaderLocD_Det_Btm: headerLocD_Det_Btm,
                    /*HeaderStubVariant_Btm: headerStubVariant_Btm,*/
                    HeightFromCoil_Btm: parseFloat(heightFromCoil_Btm),
                    DistanceFromCasingID_Btm: parseFloat(distanceFromCasingID_Btm),

                    HeaderEndDistD1_Btm: parseFloat(headerEndDistD1_Btm),
                    HeaderEndDistD2_Btm: parseFloat(headerEndDistD2_Btm),
                    HeaderConnection_Btm: headerConnection_Btm,
                    FieldWeldBetweenHeader_Btm: fieldWeldBetweenHeader_Btm,
                    NoOfFieldWeld_Btm: parseInt(noOfFieldWeld_Btm),
                    FieldWeldLoc1_Btm: parseFloat(fieldWeldLoc1_Btm),
                    FieldWeldLoc2_Btm: parseFloat(fieldWeldLoc2_Btm),
                    FieldWeldLoc3_Btm: parseFloat(fieldWeldLoc3_Btm),

                    SealPadRequired_Btm: sealPadRequired_Btm,
                    SealPadWidth_Btm: parseFloat(sealPadWidth_Btm),
                    SealPadThick_Btm: parseFloat(sealPadThick_Btm),
                    SealPadMaterial_Btm: sealPadMaterial_Btm,
                    SealPadDistance_Btm: parseFloat(sealPadDistance_Btm),
                    SealPadDistance_Btm1: parseFloat(sealPadDistance_Btm1),
                    EndPlatePosition_Btm: endPlatePosition_Btm,
                    EndPlateThk_Btm: parseFloat(endPlateThk_Btm),
                    EndPlateMaterial_Btm: endPlateMaterial_Btm,

                    InspectionNozzle_Btm: inspectionNozzle_Btm,
                    InspectionNozzlePosition_Btm: inspectionNozzlePosition_Btm,
                    InspectionNozzleOD_Btm: parseFloat(inspectionNozzleOD_Btm),
                    InspectionNozzleThk_Btm: parseFloat(inspectionNozzleThk_Btm),
                    InspectionNozzleMaterial_Btm: inspectionNozzleMaterial_Btm,

                    BafflePadRequired_Btm: bafflePadRequired_Btm,
                    BafflePadWidth_Btm: parseFloat(bafflePadWidth_Btm),
                    BafflePadThk_Btm: parseFloat(bafflePadThk_Btm),
                    BafflePadMaterial_Btm: bafflePadMaterial_Btm,
                    BafflePadOrientation_Btm: parseFloat(bafflePadOrientation_Btm),
                    BafflePadLength_Btm: parseFloat(bafflePadLength_Btm),

                    ExpPadRequired_Btm: expPadRequired_Btm,
                    ExpPadLocation_Btm: expPadLocation_Btm,
                    ExpPadLocNew_Btm: parseFloat(expPadLocNew_Btm),
                    ExpPadLength_Btm: parseFloat(expPadLength_Btm),
                    ExpPadThk_Btm: parseFloat(expPadThk_Btm),
                    ExpPadMaterial_Btm: expPadMaterial_Btm,

                    //NoOfBranch_Btm: parseInt(noOfBranch_Btm),
                    BranchDistanceArray_Btm: branchDistanceArray_Btm.map(val => parseFloat(val)),
                    BranchType_Btm: branchType_Btm,
                    BranchLength_Btm: parseFloat(branchLength_Btm),
                    BranchDistanceX_Btm: parseFloat(branchDistanceX_Btm),
                    BranchDistanceY_Btm: parseFloat(branchDistanceY_Btm),
                    BranchRadius_Btm: parseFloat(branchRadius_Btm),
                    BranchAngle_Btm: parseFloat(branchAngle_Btm),
                    BranchOD_Btm: parseFloat(branchOD_Btm),
                    BranchThk_Btm: parseFloat(branchThk_Btm),
                    BranchMaterial_Btm: branchMaterial_Btm,

                    BranchPadRequired_Btm: branchPadRequired_Btm,
                    BranchPadWidth_Btm: parseFloat(branchPadWidth_Btm),
                    BranchPadThk_Btm: parseFloat(branchPadThk_Btm),
                    BranchPadMaterial_Btm: branchPadMaterial_Btm,
                    BranchPadDistance_Btm: parseFloat(branchPadDistance_Btm),

                    ConnectingPipeSize_Btm: parseFloat(connectingPipeSize_Btm),
                    ConnectingPipeThk_Btm: parseFloat(connectingPipeThk_Btm),
                    ConnectingPipeSize_Btm_Head_End: parseFloat(connectingPipeSize_Btm_Head_End),
                    ConnectingPipeThk_Btm_Head_End: parseFloat(connectingPipeThk_Btm_Head_End),
                    DrainNozzleReq_Btm: drainNozzleReq_Btm,
                    DrainNozzlePosition_Btm: drainNozzlePosition_Btm,
                    DrainNozzleLocation_Btm: parseFloat(drainNozzleLocation_Btm),
                    DrainNozzleOD_Btm: parseFloat(drainNozzleOD_Btm),
                    DrainNozzleThk_Btm: parseFloat(drainNozzleThk_Btm),
                    DrainNozzleMaterial_Btm: drainNozzleMaterial_Btm,
                    DrainNozzleLength_Btm: parseFloat(drainNozzleLength_Btm),
                    ConnectingPipeSizeDrain_Btm: parseFloat(connectingPipeSizeDrain_Btm),
                    HeaderStubs_Btm: headerStubInputs_Btm,

                }
            };

            drawShape(
                "execute-Detailing",
                parameters,
                "✅ Detailing Execution completed successfully!"
            );
        }

        if (tab === "GA Assembly") {
            parameters = {
                GAAssemblyStage: {
                    // 👉 only thermal assembly inputs
                    No_Of_ComponentsDet: noOfComponentsDet,
                    Comp_Name_ArrayDet: compNameArrayDet.map(val => val),
                    Comp_Distance_ArrayDet: compDistanceArrayDet.map(val => parseFloat(val)),
                    ComponentMode: componentMode,
                    ComponentName_Ind: componentName_Ind,
                    TieMember_Req: tieMember_Req,
                    TieMemberToCoilDist: parseFloat(tieMemberToCoilDist),
                    Lug_Req: lug_Req,

                    //TieMemberReqArray: tieMemberReqArr.map(val => val),
                    ///* TieMemberDistArray: tieMemberDistArr.map(val => parseFloat(val)),*/
                    //TieMemberDistArray: tieMemberDistArr.map((val, i) =>
                    //    tieMemberReqArr[i] === "YES"
                    //        ? (val !== "" && val !== undefined ? parseFloat(val) : 0)
                    //        : 0
                    //),
                    //LugReqArray: lugReqArr.map(val => val),

                    Assembly_Dwg_No: parseFloat(assemblyDwgNo),
                    Fabrication_Dwg_No: parseFloat(fabricationDwgNo),
                    Header_Dwg_No: parseFloat(headerDwgNo),
                    FAB_BOM_Item_Code: fabBomItemCode,
                    Header_BOM_Item_Code: headerBomItemCode,
                }
            };

            drawShape(
                "execute-GAAssembly",
                parameters,
                "✅ GA Assembly Execution completed successfully!"
            );
        }

    };

    const drawShape = async (endpoint, body, successMsg) => {
        await handleAsync(async () => {
            const res = await fetch(`${baseUrl}/${endpoint}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
            });
            const data = await res.json();
            if (data.success) showSnack(successMsg, "success");
            else showSnack(data.error || "⚠️ Execution failed.", "error");
        });
    };

    const downloadAgent = () => {
        const link = document.createElement("a");
        link.href = "https://drive.google.com/file/d/17GJWiPlVZdO5biLj2lfmAv1gLDMo4FHK/view?usp=drive_link";
        link.target = "_blank";
        link.download = "Isgec_Thermal.exe";
        document.body.appendChild(link);
        link.click();
    };

    //const yesNoOptions = ["YES", "NO"];

    //const lhsRhsOptions = ["LHS", "RHS"];

    const renderInputField = (
        label,
        value,
        setter,
        type = "text",
        options = null,
        imageLabel = null,
        id = "",
        extraProps = {},

    ) => (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                mb: 2,
                gap: 4, // spacing between label and input
                width: "100%",
            }}
            onClick={() => imageLabel && handleImageChange(imageLabel)}
        >
            {/* Fixed-width label */}
            <Box sx={{ width: "240px" }}>
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: "1rem",
                        color: "#ffffff",
                    }}
                >
                    {label}
                </Typography>
            </Box>

            {/* Fixed-width input field */}
            <Box sx={{ width: "300px" }}>
                {options ? (
                    <TextField
                        id={id}
                        select
                        value={value}
                        onChange={(e) => setter(e.target.value)}
                        variant="outlined"
                        size="small"
                        fullWidth
                        disabled={extraProps.disabled}
                        {...extraProps}

                        sx={{
                            backgroundColor: "#ffffff",
                            borderRadius: 1,
                        }}
                        InputProps={{
                            sx: {
                                color: "#000000",
                                fontSize: "0.8rem",
                            },
                        }}
                        SelectProps={{
                            MenuProps: {
                                PaperProps: {
                                    sx: {
                                        backgroundColor: "#ffffff",
                                        color: "#000000",
                                    },
                                },
                            },
                        }}
                    >
                        {options.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                ) : (
                    <TextField
                        id={id}
                        value={value}
                        onChange={(e) => setter(e.target.value)}
                        type={type}
                        variant="outlined"
                        size="small"
                        fullWidth
                        disabled={extraProps.disabled}
                        {...extraProps}

                        sx={{
                            backgroundColor: "#ffffff",
                            borderRadius: 1,
                        }}
                        InputProps={{

                            sx: {

                                color: "#000000",
                                fontSize: "0.8rem",
                            },
                        }}
                    />
                )}
            </Box>
        </Box>
    );

    return (

        <ThemeProvider theme={theme}>
            <CssBaseline />
            {loading && <LinearProgress />}

            <Box sx={{ display: "flex", height: "100vh" }}>
                {/* Left Sidebar */}
                <Box sx={{ width: "250px", backgroundColor: "#EBF2FD", p: 2 }}>
                    <Typography variant="h6" gutterBottom>Stages</Typography>
                    <Button
                        fullWidth
                        variant={selectedStage === "Common" ? "contained" : "outlined"}
                        onClick={() => {
                            setSelectedStage("Common");
                            setImageSrc(require("./Images/Default.png")); // reset image
                        }}

                        sx={{ mb: 2 }}
                    >
                        Common Inputs
                    </Button>
                    {/* Common Inputs Button */}
                    <Button
                        fullWidth
                        variant={selectedStage === "Thermal" ? "contained" : "outlined"}
                        onClick={() => {
                            setSelectedStage("Thermal");
                            setImageSrc(require("./Images/Default.png")); // reset image

                        }}

                        sx={{ mb: 2 }}
                    >
                        Thermal Inputs
                    </Button>



                    <Button
                        fullWidth
                        variant={selectedStage === "Detailing" ? "contained" : "outlined"}
                        onClick={() => {
                            setSelectedStage("Detailing");
                            setImageSrc(require("./Images/Default.png")); // reset image
                        }}
                        sx={{ mb: 2 }}
                    >
                        GA & Detail Inputs.
                    </Button>

                    {/* Add more buttons here for "Thermal", "GA Assembly", etc. */}
                </Box>



                {/* Right Panel */}
                <Box sx={{ display: "flex", flex: 1 }}>
                    {/* Scrollable Input Panel */}
                    <Box sx={{ flex: 1, p: 3, overflowY: "auto" }}>
                        <Box display="flex" alignItems="center" gap={2} mb={2}>
                            <img src={logo} alt="Logo" height="60" />
                            <Typography variant="h5" sx={{ color: "#e0e0e0" }}>
                                CWHRB Coil Automation
                            </Typography>

                        </Box>

                        <Paper
                            elevation={1}
                            sx={{
                                backgroundColor: "#e3f2fd",
                                px: 2,
                                py: 0.5,        // smaller vertical padding
                                mb: 2,
                                borderRadius: 1,
                                maxWidth: "fit-content",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: "1.0rem", // smaller font
                                    fontWeight: 500,
                                    color: "#0d47a1",
                                }}
                            >
                                {agentStatus}
                            </Typography>
                        </Paper>


                        {showInstallMsg && (
                            <Paper sx={{ backgroundColor: "#fff3cd", p: 2, my: 2 }}>
                                <Typography color="#856404">⚠️ Please install the one-time setup to continue.</Typography>
                                <Button variant="outlined" onClick={downloadAgent} sx={{ mt: 1 }}>⬇️ Download</Button>
                            </Paper>
                        )}

                        {selectedStage === "Common" && (
                            <>

                                <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>

                                    {renderInputField("Project Id", projectId, setProjectId, "text")}
                                    {renderInputField("Client", title, setTitle, "text")}
                                    {renderInputField("Capacity", capacity, setCapacity, "text")}
                                    {renderInputField("Standard", standard, setStandard, "text", ["IBR", "ASME"])}
                                    {renderInputField("Boiler Type", boilerType, setBoilerType, "text", ["AQC", "PH"])}
                                    {renderInputField("Group Name", group, setGroup, "text")}
                                    {renderInputField("Responsible Department", department, setDepartment, "text")}
                                    {renderInputField("I.W.T", iwt, setIWT, "text")}

                                </Box>

                            </>
                        )}

                        {selectedStage === "Thermal" && (
                            <>



                                {/* --- MAIN TAB GROUP (Design vs Thermal Assembly) --- */}
                                <Tabs
                                    value={mainThermalTab}
                                    onChange={(e, newValue) => setMainThermalTab(newValue)}
                                    TabIndicatorProps={{ style: { backgroundColor: "#ffffff" } }}
                                    sx={{
                                        mb: 3,
                                        "& .MuiTab-root": {
                                            color: "#ffffff",
                                            marginRight: "30px",
                                            textTransform: "none",
                                            fontSize: "1rem",
                                        },
                                        "& .MuiTab-root.Mui-selected": {
                                            color: "#ffffff",
                                            fontWeight: "bold",
                                        },
                                    }}
                                >
                                    <Tab label="Component Design" />
                                    <Tab label="Thermal Assembly" />
                                </Tabs>

                                {/* ------------------- TAB 1: COMPONENT DESIGN ------------------- */}
                                {mainThermalTab === 0 && (
                                    <>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                mb: 2,
                                                gap: 4,
                                                width: "100%",
                                            }}
                                        >
                                            {/* Label in white */}
                                            <Box sx={{ minWidth: "200px", color: "white" }}>
                                                Select Component
                                            </Box>

                                            {/* Radio Buttons */}
                                            <RadioGroup
                                                row
                                                value={componentName || "New"} // default = "New"
                                                onChange={(e) => setComponentName(e.target.value)}
                                            >
                                                <FormControlLabel
                                                    value="New"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "white",
                                                                "&.Mui-checked": {
                                                                    color: "white", // checked circle = black
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="New"
                                                    sx={{ color: "white" }}
                                                />
                                                <FormControlLabel
                                                    value="Existing"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "white",
                                                                "&.Mui-checked": {
                                                                    color: "white", // checked circle = black
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="Existing"
                                                    sx={{ color: "white" }}
                                                />
                                            </RadioGroup>
                                        </Box>

                                        {/* Conditionally render only if "Existing" is selected */}
                                        {componentName === "Existing" && (
                                            <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center" }}>

                                                        {/* Dropdown (folders ending with _number) */}
                                                        {renderInputField(
                                                            "Select Component",
                                                            componentName_Thr,
                                                            setComponentName_Thr,
                                                            "text",
                                                            folderOptions // 👈 dropdown options come from filtered folder names
                                                        )}
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            size="small"
                                                            sx={{
                                                                ml: 1,
                                                                py: 1,        // reduce vertical padding
                                                                bottom: "8px",
                                                                left: "10px",
                                                                minHeight: 25,  // smaller height
                                                                alignSelf: "center",
                                                                borderTopLeftRadius: "auto",
                                                                borderBottomLeftRadius: "auto",
                                                            }}

                                                            onClick={handleChooseFolder}
                                                        >
                                                            SQL
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )}




                                        <Box
                                            sx={{
                                                backgroundColor: "#ffffff",    // light red background
                                                color: "#d32f2f",             // strong red text
                                                fontWeight: "bold",
                                                padding: "10px 16px",
                                                borderRadius: "8px",
                                                mb: 2,
                                                border: "1px solid #f44336",  // optional darker red border
                                            }}
                                        >
                                            Note:- While giving the first component input, please ensure the maximum number of starts.
                                        </Box>

                                        {/* Tabs for Thermal Sections */}
                                        <Tabs
                                            value={thermalTab}
                                            onChange={(e, newValue) => setThermalTab(newValue)}
                                            TabIndicatorProps={{ style: { backgroundColor: "#ffffff" } }} // white underline
                                            sx={{
                                                mb: 2,
                                                "& .MuiTab-root": {
                                                    color: "#ffffff",          // unselected
                                                    marginRight: "20px",
                                                },
                                                "& .MuiTab-root.Mui-selected": {
                                                    color: "#ffffff",          // selected
                                                    fontWeight: "bold",
                                                }
                                            }}

                                        >
                                            <Tab label="Common" />
                                            <Tab label="Tube" />
                                            <Tab label="Banking" />
                                            <Tab label="Header" />
                                            <Tab label="Casing" />

                                        </Tabs>


                                        {/* Render Tab Content */}
                                        {thermalTab === 0 && (
                                            <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>
                                                {renderInputField("Component Name Prefix", pressure, setPressure, "text", ["-", "HP", "HP Primary", "LP", "Condensate", "Water", "Additional Water"])}
                                                {renderInputField("Component Name", name1, setName1, "text", ["Superheater", "Evaporator", "Economiser", "Preheater", "Sacrificing tubes"])}
                                                {renderInputField("Component Serial No.", compNo, setCompNo, "text", ["-", "1", "2", "3", "4", "5", "6", "7", "8"])}
                                                {renderInputField("No. of Start", noOfStart1, setNoOfStart1, "text", ["1", "2", "3", "4", "5"], "", { disabled: name1 === "Sacrificing tubes" })}
                                                {renderInputField("Despatch", despatch, setDespatch, "text", ["Modular", "Non Modular"], "NO OF START", "", { disabled: name1 === "Sacrificing tubes" })}
                                                {renderInputField("Drawing No", drawingNo, setDrawingNo, "text", null, null, "")}

                                            </Box>
                                        )}

                                        {/*Tube Tab*/}
                                        {thermalTab === 1 && (
                                            <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>

                                                {renderInputField("Tube Type", tubeType, setTubeType, "text", ["Finned", "Plain"], null, "", boilerType === "PH" ? { disabled: true } : {}  // lock Tube Type if Boiler Type = PH
                                                )}
                                                {renderInputField("Tube OD", tubeOd, setTubeOd, "number")}
                                                {renderInputField("Tube Thick", tubeThk, setTubeThk, "number")}

                                                {name1 === "Sacrificing tubes" && (
                                                    <>
                                                        {renderInputField("Length of Sacrificing tubes", tubeLength, setTubeLength, "number")}
                                                        {renderInputField("No. of Tube in Wide", tubesInWidth, setTubesInWidth, "number", null, "bank-single")}
                                                    </>
                                                )}
                                                {name1 !== "Sacrificing tubes" && (
                                                    <>
                                                        {tubeType === "Finned" && (
                                                            <>
                                                                {renderInputField("Effective Length", effLen, setEffLen, "number", null, "Effective_Length_Finned_Tube")}
                                                            </>
                                                        )}
                                                        {tubeType === "Plain" && (
                                                            <>
                                                                {renderInputField("Effective Length", effLen, setEffLen, "number", null, "Effective_Length_Plain_Tube")}
                                                            </>
                                                        )}
                                                        {renderInputField("Width of the Bank", wdBank, setWdBank, "number", null, null, "", { disabled: true })}
                                                    </>
                                                )}

                                                {renderInputField("Tube Material Combination", matComb, setMatComb, "text", name1 === "Sacrificing tubes" ? ["Single"] : ["Single", "Combined"])}
                                                {renderInputField("Tube Material-1", tubeMat1, setTubeMat1, "text", ["SA 192", "SA 210 GR A1", "SA 179", "SA 210 GR C", "SA 213 GR T11", "SA 213 GR T22", "SA 213 GR T91", "SA 213 GR TP304H", "SA 213 GR TP310H", "SA 213 GR TP310HCBN", "SA 213 GR TP316", "SA 213 GR TP347H", "SA 213 GR TP347HFG"])}
                                                {renderInputField("Tube Material-1%", tubeMat1Per, setTubeMat1Per, "text")}

                                                {matComb === "Combined" && (
                                                    <>

                                                        {renderInputField("Tube Material-2", tubeMat2, setTubeMat2, "text", ["SA 192", "SA 210 GR A1", "SA 179", "SA 210 GR C", "SA 213 GR T11", "SA 213 GR T22", "SA 213 GR T91", "SA 213 GR TP304H", "SA 213 GR TP310H", "SA 213 GR TP310HCBN", "SA 213 GR TP316", "SA 213 GR TP347H", "SA 213 GR TP347HFG"])}
                                                        {renderInputField("Tube Material-2%", tubeMat2Per, setTubeMat2Per, "text")}

                                                    </>
                                                )}


                                                {tubeType === "Finned" && (
                                                    <>
                                                        {renderInputField("Longitudinal Pitch", longitudinalPitch, setLongitudinalPitch, "number", null, "Effective_Length_Finned_Tube")}
                                                        {renderInputField("No of Tube in Deep", tubesInDeepCommon, setTubesInDeepCommon, "number", null, "No_of_Tube_in_Deep_Finned_Tube")}
                                                        {renderInputField("Transverse Pitch", transversePitch, setTransversePitch, "number", null, "No_of_Tube_in_Deep_Finned_Tube")}
                                                    </>
                                                )}
                                                {tubeType === "Plain" && (
                                                    <>
                                                        {renderInputField("Longitudinal Pitch", longitudinalPitch, setLongitudinalPitch, "number", null, "Effective_Length_Plain_Tube")}
                                                        {renderInputField("No of Tube in Deep", tubesInDeepCommon, setTubesInDeepCommon, "number", null, "No_of_Tube_in_Deep_Plain_Tube")}
                                                        {renderInputField("Transverse Pitch", transversePitch, setTransversePitch, "number", null, "No_of_Tube_in_Deep_Plain_Tube")}
                                                    </>
                                                )}



                                                {tubeType === "Finned" && (
                                                    <>
                                                        {renderInputField("Fin OD", finOd, setFinOd, "number", null, "Finned_Tube")}
                                                        {renderInputField("Fin Thick", finThk, setFinThk, "number", null, "Finned_Tube")}
                                                        {renderInputField("Fin Pitch", finTubePitch, setFinTubePitch, "number", null, "Finned_Tube")}
                                                        {renderInputField("Fin Material-1", finMat1, setFinMat1, "text", ["CS(IS 513 EDD)", "SS 409L", "JSL409L", "SS304"])}


                                                        {matComb === "Combined" && (
                                                            <>
                                                                {renderInputField("Fin Material-2", finMat2, setFinMat2, "text", ["CS(IS 513 EDD)", "SS 409L", "JSL409L", "SS304"])}

                                                            </>
                                                        )}

                                                        {renderInputField("Fin Type", finType, setFinType, "text", ["HELICAL SOLID", "SPIRAL WOUND - SOLID"])}

                                                    </>

                                                )}
                                                {tubeType === "Plain" && (
                                                    <>

                                                    </>
                                                )}

                                                {name1 !== "Sacrificing tubes" && (
                                                    coilLoops.map((val, idx) =>
                                                        renderInputField(
                                                            `Coil Loop – ${idx + 1} Radius (R${idx + 1})`,
                                                            val,
                                                            (newVal) => {
                                                                const updated = [...coilLoops];
                                                                updated[idx] = newVal;
                                                                setCoilLoops(updated);
                                                            },
                                                            "number", null, `Coil_Loop_${idx + 1}_Radius_(R${idx + 1})`)
                                                    )

                                                )}

                                            </Box>
                                        )}

                                        {/*Banking Tab*/}

                                        {thermalTab === 2 && (

                                            <Box

                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    mat: 1,
                                                    position: "relative",
                                                    opacity: name1 !== "Sacrificing tubes" ? 1 : 0.5, // grey out if not PH
                                                    pointerEvents: name1 !== "Sacrificing tubes" ? "auto" : "none", // prevent interaction when greyed
                                                    transition: "opacity 0.3s",
                                                }}

                                            >

                                                <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>
                                                    {renderInputField("Banking Type", bankType, setBankType, "text", ["Single Banking", "Multi Banking"])}

                                                    {renderInputField(
                                                        "Tube Bend Type",
                                                        tubeBendType,
                                                        setTubeBendType,
                                                        "text",
                                                        ["2D Bend", "3D Bend"],   // example options
                                                        null,
                                                        "",
                                                        bankType === "Multi Banking" ? { disabled: true } : {}
                                                    )}

                                                    {bankType === "Single Banking" && (
                                                        <>
                                                            {renderInputField("No. of Tube in Wide", tubesInWidth, setTubesInWidth, "number", null, "Banking_Type_Single_Banking")}
                                                            {tubeBendType === "3D Bend" && (
                                                                renderInputField(
                                                                    "Stub 3D Bend Position",
                                                                    stub3DBendPosition,
                                                                    setStub3DBendPosition,
                                                                    "text", // or "select" if you want dropdown
                                                                    ["Front", "Back"], "Tube_Bend_Type_3D_Bend_Position" // optional options
                                                                )
                                                            )}
                                                        </>
                                                    )}

                                                    {bankType === "Multi Banking" && (
                                                        <>
                                                            {renderInputField("No. of Banks", noOfBanks, (val) => {
                                                                setNoOfBanks(val);
                                                                const count = parseInt(val);
                                                                setTubeInWideArray(Array(count).fill(""));
                                                                setBankDistanceArray(Array(count - 1).fill(""));
                                                            }, "text", ["2", "3", "4"])}

                                                            {tubeInWideArray.map((_, index) => (
                                                                <React.Fragment key={index}>
                                                                    {renderInputField(`No. of Tube in Wide B${index + 1}`, tubeInWideArray[index], (val) => {
                                                                        const updated = [...tubeInWideArray];
                                                                        updated[index] = val;
                                                                        setTubeInWideArray(updated);
                                                                    })}

                                                                    {index < bankDistanceArray.length && renderInputField(`Bank Gap Distance (B${index + 1}-B${index + 2})`, bankDistanceArray[index], (val) => {
                                                                        const updatedDistances = [...bankDistanceArray];
                                                                        updatedDistances[index] = val;
                                                                        setBankDistanceArray(updatedDistances);
                                                                    })}
                                                                </React.Fragment>
                                                            ))}

                                                            {renderInputField("Tube Radius at Bank Gap", radiusGap, setRadiusGap, "number", null, null, "")}

                                                        </>
                                                    )}

                                                </Box>
                                            </Box>

                                        )}

                                        {thermalTab === 3 && (

                                            <Box

                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    mat: 1,
                                                    position: "relative",
                                                    opacity: name1 !== "Sacrificing tubes" ? 1 : 0.5, // grey out if not PH
                                                    pointerEvents: name1 !== "Sacrificing tubes" ? "auto" : "none", // prevent interaction when greyed
                                                    transition: "opacity 0.3s",
                                                }}

                                            >
                                                {renderInputField("Type Of Flow", typeOfFlow, setTypeOfFlow, "text", ["Parallel", "Counter"])}

                                                <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>

                                                    <Box
                                                        sx={{
                                                            mt: 2,
                                                            mb: 2,
                                                            px: 2,
                                                            py: 1,
                                                            fontWeight: "bold",
                                                            fontSize: "16px",
                                                            borderRadius: "5px",
                                                            backgroundColor: "#e3f2fd",
                                                            color: "Black",
                                                            width: "fit-content"
                                                        }}
                                                    >
                                                        Top Header
                                                    </Box>

                                                    {/*<h5 style={{ color: "white", marginBottom: "10px" }}>Top Header</h5>*/}

                                                    {renderInputField("Header OD", headerDia, setHeaderDia, "number", null, "Header_OD_Thk_Radius")}
                                                    {renderInputField("Header Thick", headerThk, setHeaderThk, "number", null, "Header_OD_Thk_Radius")}
                                                    {renderInputField("Header Material", headerMat, setHeaderMat, "text", ["SA 106 GR B", "SA 106 GR C", "SA 335 GR P11", "SA 335 GR P22", "SA 335 GR P91", "SA 312 GR TP304", "SA 312 GR TP304L", "SA 312 GR TP304H", "SA 312 GR TP310H", "SA 312 GR TP316L", "SA 312 GR TP316", "SA 312 GR TP316H", "SA 312 GR TP321", "SA 312 GR TP321H", "SA 312 GR TP347", "SA 312 GR TP347H"])}
                                                    {renderInputField("Tube Radius at Header Stub", radiusHeaderGap, setRadiusHeaderGap, "number", null, null, "Header_OD_Thk_Radius")}
                                                    {renderInputField("Header Partition Plate Requirement", partition, setPartition, "text", ["YES", "NO"], "Header_Partition_Plate_Requirement")}

                                                    {partition === "YES" && (
                                                        <>
                                                            {/* No of Components Dropdown */}
                                                            {renderInputField(
                                                                "No of Count",
                                                                noOfCount,
                                                                (val) => {
                                                                    setNoOfCount(val);
                                                                    const count = parseInt(val);
                                                                    setPartitionDistArray_Rows(Array(count).fill("")); // previous plates only
                                                                    if (partitionImageMap[val]) {
                                                                        setImageSrc(partitionImageMap[val]);
                                                                    } else {
                                                                        //setImageSrc(null);
                                                                    }
                                                                },
                                                                "text",
                                                                ["1", "2", "3"]
                                                            )}


                                                            {renderInputField(
                                                                "Partition Plate Material",
                                                                partitionPlateMat,
                                                                setPartitionPlateMat,
                                                                "text",
                                                                ["SA 516 GR 60", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"]

                                                            )}


                                                            {/* Show previous plate inputs if count > 1 */}
                                                            {parseInt(noOfCount) >= 1 && partitionDistArray_Rows.map((_, index) => (
                                                                <React.Fragment key={index}>
                                                                    {renderInputField(
                                                                        `Coil Rows covered in Partition Plate - ${index + 1}`,
                                                                        partitionDistArray_Rows[index],
                                                                        (val) => {
                                                                            const updated = [...partitionDistArray_Rows];
                                                                            updated[index] = val;
                                                                            setPartitionDistArray_Rows(updated);
                                                                        },
                                                                        "number"
                                                                    )}
                                                                </React.Fragment>
                                                            ))}



                                                            {renderInputField(
                                                                "Partition Plate Thick",
                                                                partitionPlateThk,
                                                                setPartitionPlateThk,
                                                                "number", null, "Coil_Rows_covered_in_Partition_Plate_1"
                                                            )}
                                                        </>
                                                    )}


                                                    {renderInputField("Header Position", headerPosC, setHeaderPosC, "text", ["LHS", "RHS"])}
                                                    {renderInputField("Header Location", headerLocD, setHeaderLocD, "text", ["In_Side_Casing", "Out_Side_Casing"])}

                                                    <Box
                                                        sx={{
                                                            mt: 6,          // ⬅️ Adds space between Top and Bottom section
                                                            mb: 2,
                                                            px: 2,
                                                            py: 1,
                                                            fontWeight: "bold",
                                                            fontSize: "16px",
                                                            borderRadius: "5px",
                                                            backgroundColor: "#e3f2fd",
                                                            color: "Black",
                                                            width: "fit-content"
                                                        }}
                                                    >
                                                        Bottom Header
                                                    </Box>

                                                    {/*<h5 style={{ color: "white", marginBottom: "10px" }}>Bottom Header</h5>*/}

                                                    {renderInputField("Header Dia ", headerDiaBtm, setHeaderDiaBtm, "number", null, "Header_OD_Thk_Radius")}
                                                    {renderInputField("Header Thick", headerThkBtm, setHeaderThkBtm, "number", null, "Header_OD_Thk_Radius")}
                                                    {renderInputField("Header Material", headerMat_Btm, setHeaderMat_Btm, "text", ["SA 106 GR B", "SA 106 GR C", "SA 335 GR P11", "SA 335 GR P22", "SA 335 GR P91", "SA 312 GR TP304", "SA 312 GR TP304L", "SA 312 GR TP304H", "SA 312 GR TP310H", "SA 312 GR TP316L", "SA 312 GR TP316", "SA 312 GR TP316H", "SA 312 GR TP321", "SA 312 GR TP321H", "SA 312 GR TP347", "SA 312 GR TP347H"])}
                                                    {renderInputField("Tube Radius at Header Stub", radiusHeaderGap_Btm, setRadiusHeaderGap_Btm, "number", null, null, "Header_OD_Thk_Radius")}
                                                    {renderInputField("Header Partition Plate Requirement", partition_Btm, setPartition_Btm, "text", ["YES", "NO"], "Header_Partition_Plate_Requirement")}

                                                    {partition_Btm === "YES" && (
                                                        <>
                                                            {/* No of Components Dropdown */}
                                                            {renderInputField(
                                                                "No of Count",
                                                                noOfCount_Btm,
                                                                (val) => {
                                                                    setNoOfCount_Btm(val);
                                                                    const count = parseInt(val);
                                                                    setPartitionDistArrayRows_Btm(Array(count).fill("")); // previous plates only
                                                                    if (partitionImageMap_Btm[val]) {
                                                                        setImageSrc(partitionImageMap_Btm[val]);
                                                                    } else {
                                                                        //setImageSrc(null);
                                                                    }
                                                                },
                                                                "text",
                                                                ["1", "2", "3"]
                                                            )}



                                                            {renderInputField(
                                                                "Partition Plate Material",
                                                                partitionPlateMat_Btm,
                                                                setPartitionPlateMat_Btm,
                                                                "text",
                                                                ["SA 516 GR 60", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"]
                                                            )}

                                                            {/* Show previous plate inputs if count > 1 */}
                                                            {parseInt(noOfCount_Btm) >= 1 && partitionDistArrayRows_Btm.map((_, index) => (
                                                                <React.Fragment key={index}>
                                                                    {renderInputField(
                                                                        `Coil Rows covered in Partition Plate -  ${index + 1}`,
                                                                        partitionDistArrayRows_Btm[index],
                                                                        (val) => {
                                                                            const updated = [...partitionDistArrayRows_Btm];
                                                                            updated[index] = val;
                                                                            setPartitionDistArrayRows_Btm(updated);
                                                                        },
                                                                        "number"
                                                                    )}
                                                                </React.Fragment>
                                                            ))}

                                                            {renderInputField(
                                                                "Partition Plate Thick",
                                                                partitionPlateThk_Btm,
                                                                setPartitionPlateThk_Btm,
                                                                "number", null, "Coil_Rows_covered_in_Partition_Plate_1"
                                                            )}
                                                        </>
                                                    )}



                                                    {renderInputField(
                                                        "Header Position",
                                                        headerPosCBtm,
                                                        setHeaderPosCBtm,
                                                        "text",
                                                        ["LHS", "RHS"],
                                                        null,
                                                        "",
                                                        {
                                                            disabled: tubeBendType === "3D Bend"
                                                        }
                                                    )}

                                                    {renderInputField("Header Location", headerLocDBtm, setHeaderLocDBtm, "text", ["In_Side_Casing", "Out_Side_Casing"])}

                                                </Box>

                                            </Box>
                                        )}

                                        {thermalTab === 4 && (
                                            <Box
                                                sx={{ display: "flex", flexDirection: "column", mat: 1, position: "relative", transition: "opacity 0.3s", }}
                                            >
                                                {/* Inputs container: greyed + non-interactive only when name1 === "Sacrificing tubes" */}
                                                <Box
                                                    sx={{ display: "flex", flexDirection: "column", mat: 1, opacity: name1 === "Sacrificing tubes" ? 0.5 : 1, pointerEvents: name1 === "Sacrificing tubes" ? "none" : "auto", }}
                                                >
                                                    {renderInputField("Gap A", gapA, handleGapAChange, "number", null, null, "", { disabled: name1 === "Sacrificing tubes" })}
                                                    {renderInputField("Gap B", gapB, () => { }, "number", null, null, "", { disabled: true })}
                                                    {renderInputField("Gap C", gapC, handleGapCChange, "number", null, null, "", { disabled: name1 === "Sacrificing tubes" })}
                                                    {/*{renderInputField("Gap D", gapD, setGapD, "number", null, null, "", { disabled: true })}*/}
                                                    {renderInputField("Gap D", gapD, () => { }, "number", null, null, "", { disabled: true })}

                                                </Box>

                                                {/* Execute Button - outside the inputs container so it's always clickable */}
                                                <Box sx={{ mt: 3, textAlign: "center" }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => executeThermal("Casing")}
                                                        sx={{ fontSize: "1.1rem", px: 4, py: 1.5 }}
                                                    >
                                                        Execute
                                                    </Button>
                                                </Box>
                                            </Box>
                                        )}

                                    </>

                                )}
                                {/* ------------------- TAB 2: THERMAL ASSEMBLY ------------------- */}
                                {mainThermalTab === 1 && (
                                    <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>

                                        {renderInputField("No of Components", noOfComponents, (val) => {
                                            setNoOfComponents(val);
                                            const count = parseInt(val);
                                            setCompNameArray(Array(count).fill(""));
                                            setCompDistanceArray(Array(count - 1).fill(""));
                                        }, "text", ["2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"])}

                                        {compNameArray.map((_, index) => (
                                            <React.Fragment key={index}>
                                                {renderInputField(`Component - C${index + 1}`, compNameArray[index], (val) => {
                                                    const updated = [...compNameArray];
                                                    updated[index] = val;
                                                    setCompNameArray(updated);
                                                })}

                                                {index < compDistanceArray.length && renderInputField(`Gap B/W Components (C${index + 1}-C${index + 2})`, compDistanceArray[index], (val) => {
                                                    const updatedDistances = [...compDistanceArray];
                                                    updatedDistances[index] = val;
                                                    setCompDistanceArray(updatedDistances);
                                                })}
                                            </React.Fragment>
                                        ))}

                                        <Box sx={{ mt: 3, textAlign: "center" }}>
                                            <Button variant="contained" onClick={() => executeThermal("Thermal Assembly")} sx={{ fontSize: "1.1rem", px: 4, py: 1.5 }}>
                                                Execute
                                            </Button>
                                        </Box>

                                    </Box>
                                )}
                            </>
                        )}


                        {selectedStage === "Detailing" && (
                            <>

                                <Tabs
                                    value={mainDetailTab}
                                    onChange={(e, newValue) => setMainDetailTab(newValue)}
                                    TabIndicatorProps={{ style: { backgroundColor: "#ffffff" } }}
                                    sx={{
                                        mb: 3,
                                        "& .MuiTab-root": {
                                            color: "#ffffff",
                                            marginRight: "30px",
                                            textTransform: "none",
                                            fontSize: "1rem",
                                        },
                                        "& .MuiTab-root.Mui-selected": {
                                            color: "#ffffff",
                                            fontWeight: "bold",
                                        },
                                    }}
                                >
                                    <Tab label="Detailing Design" />
                                    <Tab label="General Assembly" />
                                </Tabs>

                                {/* ------------------- TAB 1: COMPONENT DESIGN ------------------- */}
                                {mainDetailTab === 0 && (
                                    <>

                                        <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
                                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    {renderInputField(
                                                        "Select Component",
                                                        componentName_Det,
                                                        setComponentName_Det,
                                                        "text",
                                                        folderOptions // pass folder list here as dropdown options
                                                    )}
                                                    {/* SQL Button on right side */}
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        sx={{
                                                            ml: 1,
                                                            py: 1,        // reduce vertical padding
                                                            bottom: "8px",
                                                            left: "10px",
                                                            minHeight: 25,  // smaller height
                                                            alignSelf: "center",
                                                            borderTopLeftRadius: "auto",
                                                            borderBottomLeftRadius: "auto",
                                                        }}
                                                        onClick={handleChooseFolder}
                                                    >
                                                        SQL
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>


                                        <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>
                                            {renderInputField("Element ID", elementId, setElementId, "number")}
                                        </Box>

                                        {/* Tabs for Detailing Sections */}
                                        <Tabs
                                            value={detailingTab}
                                            onChange={(e, newValue) => setDetailingTab(newValue)}
                                            TabIndicatorProps={{ style: { backgroundColor: "#ffffff" } }} // white underline
                                            sx={{
                                                mb: 2,
                                                "& .MuiTab-root": {
                                                    color: "#ffffff",          // unselected
                                                    marginRight: "20px",
                                                },
                                                "& .MuiTab-root.Mui-selected": {
                                                    color: "#ffffff",          // selected
                                                    fontWeight: "bold",
                                                }
                                            }}

                                        >
                                            <Tab label="Bank" />
                                            <Tab label="Hammering Arrangement" />
                                            <Tab label="Process Data" />
                                            <Tab label="Header" />

                                        </Tabs>

                                        {detailingTab === 0 && (

                                            <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>
                                                {/* Common Fields */}
                                                {renderInputField("No of Supports", noOfSupports, setNoOfSupports, "text", ["2", "3", "4", "5"])}

                                                {renderInputField("First Support From Coil CL", firstSupportFromCoilCL1, setFirstSupportFromCoilCL1, "text")}

                                                {Array.from({ length: Math.max(Number(noOfSupports) - 1, 0) }, (_, index) => {
                                                    const supportIndex = index + 2; // start from Support 2
                                                    return (
                                                        <Box key={supportIndex}>
                                                            {renderInputField(
                                                                `Support ${supportIndex} Dist From last Support`,
                                                                supportPositions[supportIndex - 1],
                                                                (val) => {
                                                                    const updated = [...supportPositions];
                                                                    updated[supportIndex - 1] = val;
                                                                    setSupportPositions(updated);
                                                                },
                                                                "text"
                                                            )}
                                                        </Box>
                                                    );
                                                })}
                                                {/*{renderInputField("Pitch of Support", pitchOfSupport, setPitchOfSupport, "text")}*/}

                                                {/* Plain Tube Only */}
                                                {tubeType === "Plain" && (
                                                    <>
                                                        {renderInputField("Clamp Plate Material", clampPlateMat, setClampPlateMat, "text", ["SA 516 GR 60","IS 2062 E250 A", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}
                                                        {renderInputField("Spacer Plate Material", spacerPlateMat, setSpacerPlateMat, "text", ["SA 516 GR 60", "IS 2062 E250 A", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}

                                                        {boilerType !== "PH" && (
                                                            <>
                                                                {renderInputField("Half Sleeve Requirement", halfSleeveReq, setHalfSleeveReq, "text", ["YES", "NO"], "No_of_Half_Sleeve_Rows")}

                                                                {halfSleeveReq === "YES" && (
                                                                    <>
                                                                        {renderInputField("No of Half Sleeve Rows", noOfHalfSleeveRows, setNoOfHalfSleeveRows, "number", ["1", "2", "3", "4", "5"], "No_of_Half_Sleeve_Rows")}
                                                                        {renderInputField("Half Sleeve Material", halfSleeveMat, setHalfSleeveMat, "text", ["SS304 - 2mmThk", "IS 513 - 3.15mm Thk"])}

                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                )}


                                                {/* Finned Tube Only */}
                                                {tubeType === "Finned" && (
                                                    <>
                                                        {renderInputField("Support Sleeve OD", supportSleeveOD, setSupportSleeveOD, "text", null, "Support_Sleeve_OD_Thk_Length")}
                                                        {renderInputField("Support Sleeve Thk", supportSleeveThk, setSupportSleeveThk, "text", null, "Support_Sleeve_OD_Thk_Length")}
                                                        {renderInputField("Support Sleeve Length", supportSleeveLength, setSupportSleeveLength, "text", null, "Support_Sleeve_OD_Thk_Length")}
                                                        {renderInputField("Support Sleeve Material", supportSleeveMat, setSupportSleeveMat, "text", ["SA 106 GR B", "SA 106 GR C", "SA 335 GR P11", "SA 335 GR P22", "SA 335 GR P91", "SA 312 GR TP304", "SA 312 GR TP304L", "SA 312 GR TP304H", "SA 312 GR TP310H", "SA 312 GR TP316L", "SA 312 GR TP316", "SA 312 GR TP316H", "SA 312 GR TP321", "SA 312 GR TP321H", "SA 312 GR TP347", "SA 312 GR TP347H"])}
                                                        {renderInputField("Support Rod Material", supportRodMat, setSupportRodMat, "text", ["SA 105", "SA 182 F11 (CL1, CL2 & CL3)", "SA 182 F22 (CL1 & CL3)", "SA 182 F91", "SA 182 F304", "SA 182 F304L", "SA 182 F304H", "SA 182 F310", "SA 182 F316L", "SA 182 F316", "SA 182 F316H", "SA 182 F321", "SA 182 F321H", "SA 182 F347", "SA 182 F347H"])}
                                                        {renderInputField("Support Flat Material", supportFlatMat, setSupportFlatMat, "text", ["SA 516 GR 60", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}
                                                    </>
                                                )}

                                                {/* Fields common to both */}

                                            </Box>


                                        )}

                                        {detailingTab === 1 && (
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    mat: 1,
                                                    position: "relative",
                                                    opacity: boilerType === "PH" ? 1 : 0.5, // grey out if not PH
                                                    pointerEvents: boilerType === "PH" ? "auto" : "none", // prevent interaction when greyed
                                                    transition: "opacity 0.3s",
                                                }}
                                            >
                                                <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>
                                                    {renderInputField("No of Set", noOfSet, setNoOfSet, "text", ["Single", "Double"])}
                                                    {renderInputField("Hammering Pos", hammerPos, setHammerPos, "text", ["RHS", "LHS", "BOTH"])}
                                                    {noOfSet === "Single" && (
                                                        <>
                                                            {renderInputField("No. of Hammers Per Set–1", hammersSet1, setHammersSet1, "number")}
                                                            {renderInputField("Pitch of Hammers", pitchHammers, setPitchHammers, "number")}
                                                            {renderInputField("Hammers Set–1 Dist From Coil", hammersFromCoil1, setHammersFromCoil1, "number")}
                                                        </>
                                                    )}
                                                    {noOfSet === "Double" && (
                                                        <>
                                                            {renderInputField("No. of Hammers Per Set–1", hammersSet1, setHammersSet1, "number")}
                                                            {renderInputField("No. of Hammers Per Set-2", hammersSet2, setHammersSet2, "number")}
                                                            {renderInputField("Pitch of Hammers", pitchHammers, setPitchHammers, "number")}
                                                            {renderInputField("Hammers Set–1 Dist From Coil", hammersFromCoil1, setHammersFromCoil1, "number")}
                                                            {renderInputField("Gap B/W Hammers Set – 1 & 2", gapHammers, setGapHammers, "number")}

                                                        </>
                                                    )}

                                                    {renderInputField("Hammer Sleeve OD", hammerSleeveOD, setHammerSleeveOD, "number", null, "Hammer_Sleeve_Details")}
                                                    {renderInputField("Gap B/W Holding Plate", gapBtwHoldingPlt, setGapBtwHoldingPlt, "number", null, "Hammer_Sleeve_Details")}
                                                    {renderInputField("Hammer level from btm coil", hammerLevel, sethammerLevel, "number", null, "Hammer_Sleeve_Details")}
                                                    {renderInputField("Hammer Sleeve Thk", hammerSleeveThk, setHammerSleeveThk, "number", null, "Hammer_Sleeve_Details")}
                                                    {renderInputField("Hammer Sleeve Mat", hammerSleeveMat, setHammerSleeveMat, "text", ["SA 106 GR B","SA 210 GR A1", "SA 106 GR C", "SA 335 GR P11", "SA 335 GR P22", "SA 335 GR P91", "SA 312 GR TP304", "SA 312 GR TP304L", "SA 312 GR TP304H", "SA 312 GR TP310H", "SA 312 GR TP316L", "SA 312 GR TP316", "SA 312 GR TP316H", "SA 312 GR TP321", "SA 312 GR TP321H", "SA 312 GR TP347", "SA 312 GR TP347H"])}
                                                    {renderInputField("Holding Plate Mat", holdingPlateMat, setHoldingPlateMat, "text", ["IS 2062 E250 A","SA 516 GR 60", "IS 513 CR1", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}
                                                    {renderInputField("Hammer Clamp Mat", hammerClampMat, setHammerClampMat, "text", ["SA 516 GR 60", "IS 513 CR1", "IS 513", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}
                                                </Box>
                                            </Box>
                                        )}

                                        {detailingTab === 2 && (
                                            <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>

                                                {renderInputField("Max Work Pr (kg/sq.cm g)–Coil", coilMaxP, setCoilMaxP, "number")}
                                                {renderInputField("Max Working Temp (°C)–Coil", coilMaxT, setCoilMaxT, "number")}
                                                {renderInputField("Working Metal Temp (°C)–Coil", coilWorkT, setCoilWorkT, "number")}
                                                {renderInputField("Max Work Pr (kg/sq.cm g)–Inlet", inletMaxP, setInletMaxP, "number")}
                                                {renderInputField("Max Working Temp (°C)–Inlet", inletMaxT, setInletMaxT, "number")}
                                                {renderInputField("Working Metal Temp (°C)–Inlet", inletWorkT, setInletWorkT, "number")}
                                                {renderInputField("Max Work Pr (kg/sq.cm g)–Outlet", outletMaxP, setOutletMaxP, "number")}
                                                {renderInputField("Max Working Temp (°C)–Outlet", outletMaxT, setOutletMaxT, "number")}
                                                {renderInputField("Working Metal Temp (°C)–Outlet", outletWorkT, setOutletWorkT, "number")}
                                                {renderInputField("Flue Gas Entry Temp (°C)", flueEntryT, setFlueEntryT, "number")}
                                                {renderInputField("Flue Gas Exit Temp (°C)", flueExitT, setFlueExitT, "number")}



                                            </Box>
                                        )}

                                        {detailingTab === 3 && (
                                            <Box sx={{ display: "flex", flexDirection: "column", m: 1 }}>
                                                {/* Nested Tabs inside Detailing */}
                                                <Tabs
                                                    value={headerTab}
                                                    onChange={(e, newValue) => setHeaderTab(newValue)}
                                                    TabIndicatorProps={{ style: { backgroundColor: "white" } }} // indicator white
                                                    sx={{
                                                        mb: 8,
                                                        "& .MuiTab-root": {
                                                            color: "white", // text color for all tabs
                                                            variant: "fullWidth",
                                                            marginRight: "100px",   // 🔥 increase gap between tabs
                                                            paddingX: "50px",      // 🔥 wider clickable area
                                                        },
                                                        "& .Mui-selected": {
                                                            color: "white !important", // keep text white even when active
                                                            variant: "fullWidth",
                                                        },
                                                    }}
                                                >
                                                    <Tab label="Top Header" />
                                                    <Tab label="Bottom Header" />
                                                </Tabs>


                                                {headerTab === 0 && (
                                                    <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>

                                                        {/*{renderInputField("Header Position (C)", headerPosC_Det, setHeaderPosC_Det, "text", ["LHS", "RHS"], "header top pos")}*/}

                                                        {renderInputField("Header Location", headerLocD_Det, setHeaderLocD_Det, "text", ["In_Side_Casing", "Out_Side_Casing"])}
                                                        {/*{renderInputField("Header Stub Variant", headerStubVariant, setHeaderStubVariant, "text", ["Short", "Long"])}*/}

                                                        {renderInputField("Header Height from CL of Coil", heightFromCoil, setHeightFromCoil, "text")}
                                                        {renderInputField("Distance from Casing ID", distanceFromCasingID, setDistanceFromCasingID, "text")}


                                                        {/*{despatch === "Non-Modular" && (*/}

                                                        {/*    renderInputField("Header Stub Weld Position", distanceFromCasingID, setDistanceFromCasingID, "text")*/}

                                                        {/*)}*/}

                                                        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mb: 4 }}>

                                                            {headerStubs.map((stub, index) => {

                                                                // ✅ ADD THIS LINE HERE
                                                                const selectedImage = getStubEndPointImage(headerPosC, stub.type);

                                                                return (
                                                                    <Box
                                                                        key={index}
                                                                        sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}
                                                                    >
                                                                        <h4 style={{ color: "white", marginBottom: "10px" }}>
                                                                            Header Stub –{index + 1}
                                                                        </h4>

                                                                        {renderInputField(
                                                                            `Header Stub –${index + 1} Type`,
                                                                            stub.type,
                                                                            (val) => {
                                                                                const newStubs = [...headerStubs];
                                                                                newStubs[index].type = val;
                                                                                setHeaderStubs(newStubs);
                                                                            },
                                                                            "number",
                                                                            ["1", "2"],
                                                                            "Header_Stub_Types"
                                                                        )}


                                                                        {renderInputField(
                                                                            `Header Stub –${index + 1} Angle`,
                                                                            stub.angle,
                                                                            (val) => {
                                                                                const newStubs = [...headerStubs];
                                                                                newStubs[index].angle = val;
                                                                                setHeaderStubs(newStubs);

                                                                                // change image when value changes
                                                                                updateStubAngleImage(index);
                                                                            },
                                                                            "number",
                                                                            null,
                                                                            null,
                                                                            "",
                                                                            {
                                                                                onClick: () => updateStubAngleImage(index),
                                                                            }
                                                                        )}

                                                                        {despatch === "Non Modular" && (
                                                                            renderInputField(
                                                                                `Header Stub –${index + 1} Weld Position`,
                                                                                stub.weldPos,
                                                                                (val) => {
                                                                                    const newStubs = [...headerStubs];
                                                                                    newStubs[index].weldPos = val;
                                                                                    setHeaderStubs(newStubs);
                                                                                },
                                                                                "number", null, "Header_Stub_Weld_Position_Top1_5"
                                                                            )
                                                                        )}

                                                                        {/* ✅ Only show distance field when type is "1" */}
                                                                        {stub.type === "1" &&
                                                                            renderInputField(
                                                                                `Stub –${index + 1} Dist from Header CL`,
                                                                                stub.distance,
                                                                                (val) => {
                                                                                    const newStubs = [...headerStubs];
                                                                                    newStubs[index].distance = val;
                                                                                    setHeaderStubs(newStubs);
                                                                                },
                                                                                "number", null, "Stub_Dist_from_Header_CL_Top"
                                                                            )}


                                                                        {tubeType === "Finned" && (

                                                                            renderInputField(
                                                                                `Stub –${index + 1} End Point Distance`,
                                                                                stub.dist_Pt,
                                                                                (val) => {
                                                                                    const newStubs = [...headerStubs];
                                                                                    newStubs[index].dist_Pt = val;
                                                                                    setHeaderStubs(newStubs);
                                                                                },
                                                                                "number",
                                                                                null,
                                                                                selectedImage   // 👈 pass resolved image key here
                                                                            )
                                                                        )}

                                                                    </Box>
                                                                );
                                                            })}

                                                        </Box>



                                                        {renderInputField("Header end dist from Last Coil-D1", headerEndDistD1, setHeaderEndDistD1, "number", null, "Header_end_dist_from_Last_Coil_D1_D2")}

                                                        {renderInputField("Header end dist from Last Coil-D2", headerEndDistD2, setHeaderEndDistD2, "number", null, "Header_end_dist_from_Last_Coil_D1_D2")}

                                                        {renderInputField("Header Connection", headerConnection, setHeaderConnection, "text", ["End Connection", "Branch Connection"])}

                                                        {renderInputField(
                                                            "Field Weld between Header",
                                                            fieldWeldBetweenHeader,
                                                            setFieldWeldBetweenHeader,
                                                            "text",
                                                            ["YES", "NO"], "Field_Weld_between_Header"
                                                        )}

                                                        {fieldWeldBetweenHeader === "YES" && (
                                                            <>
                                                                {renderInputField(
                                                                    "No of Field Weld",
                                                                    noOfFieldWeld,
                                                                    setNoOfFieldWeld,
                                                                    "number",
                                                                    ["1", "2", "3"]
                                                                )}

                                                                {/* Show fields based on count */}
                                                                {noOfFieldWeld === "1" && (
                                                                    <>
                                                                        {renderInputField("Coil Rows covered for Field Weld-1", fieldWeldLoc1, setFieldWeldLoc1, "text")}
                                                                    </>
                                                                )}

                                                                {noOfFieldWeld === "2" && (
                                                                    <>
                                                                        {renderInputField("Coil Rows covered for Field Weld-1", fieldWeldLoc1, setFieldWeldLoc1, "text")}
                                                                        {renderInputField("Coil Rows covered for Field Weld-2", fieldWeldLoc2, setFieldWeldLoc2, "text")}
                                                                    </>
                                                                )}
                                                                {noOfFieldWeld === "3" && (
                                                                    <>
                                                                        {renderInputField("Coil Rows covered for Field Weld-1", fieldWeldLoc1, setFieldWeldLoc1, "text")}
                                                                        {renderInputField("Coil Rows covered for Field Weld-2", fieldWeldLoc2, setFieldWeldLoc2, "text")}
                                                                        {renderInputField("Coil Rows covered for Field Weld-3", fieldWeldLoc3, setFieldWeldLoc3, "text")}

                                                                    </>
                                                                )}
                                                            </>
                                                        )}

                                                        {renderInputField("Header Seal Pad Requirement", sealPadRequired, setSealPadRequired, "text", ["YES", "NO"], "Header_Seal_Pad_Requirement")}
                                                        {sealPadRequired === "YES" && (
                                                            <>
                                                                {renderInputField("Header Seal Pad Width", sealPadWidth, setSealPadWidth, "number", null, "Header_Seal_Pad_Requirement")}
                                                                {renderInputField("Header Seal Pad Thick", sealPadThick, setSealPadThick, "number", null, "Header_Seal_Pad_Requirement")}
                                                                {renderInputField("Header Seal Pad Material", sealPadMaterial, setSealPadMaterial, "text", ["SA 516 GR 70","SA 106 GR B", "SA 106 GR C", "SA 335 GR P11", "SA 335 GR P22", "SA 335 GR P91", "SA 312 GR TP304", "SA 312 GR TP304L", "SA 312 GR TP304H", "SA 312 GR TP310H", "SA 312 GR TP316L", "SA 312 GR TP316", "SA 312 GR TP316H", "SA 312 GR TP321", "SA 312 GR TP321H", "SA 312 GR TP347", "SA 312 GR TP347H"])}
                                                                {renderInputField("Header Seal Pad Dist from Header End(D3)", sealPadDistance, setSealPadDistance, "number", null, "Header_end_dist_from_Last_Coil_D1_D2")}
                                                                {renderInputField("Header Seal Pad Dist from Header End(D4)", sealPadDistance1, setSealPadDistance1, "number", null, "Header_end_dist_from_Last_Coil_D1_D2")}

                                                            </>
                                                        )}



                                                        {/* Header Connection Dropdown */}
                                                        {/*{renderInputField(*/}
                                                        {/*    "Header Connection",*/}
                                                        {/*    headerConnection,*/}
                                                        {/*    setHeaderConnection,*/}
                                                        {/*    "text",*/}
                                                        {/*    ["End Connection", "Branch Connection"]*/}
                                                        {/*)}*/}

                                                        {headerConnection === "End Connection" && (
                                                            renderInputField(
                                                                "Header End Plate Position",
                                                                endPlatePosition,
                                                                (val) => {
                                                                    setEndPlatePosition(val);

                                                                    // Automatically sync Inspection Nozzle Position
                                                                    setInspectionNozzlePosition(val);
                                                                },
                                                                "text",
                                                                ["Left", "Right"]
                                                            )
                                                        )}

                                                        {renderInputField("Header End Plate Thk", endPlateThk, setEndPlateThk, "number", null, "Header_End_Plate_Thk")}
                                                        {renderInputField("Header End Plate Material", endPlateMaterial, setEndPlateMaterial, "text", ["SA 515/516 Gr.60/70/SA 105","SA 105","SA 516 GR 60", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}

                                                        {/* Conditionally render Inspection Nozzle fields only if End Connection */}


                                                        {/* Show Inspection Nozzle Required? */}

                                                        {(
                                                            (headerConnection === "Branch Connection" && Number(headerDia) > 114.3) ||
                                                            (headerConnection === "End Connection" && Number(headerDia) > 114.3)
                                                        ) && (
                                                                renderInputField(
                                                                    "Inspection Nozzle Required",
                                                                    inspectionNozzle,
                                                                    setInspectionNozzle,
                                                                    "text",
                                                                    ["YES", "NO"], "Inspection_Nozzle_Required"
                                                                )
                                                            )}

                                                        {/* If Yes → show OD / Thk / Material */}
                                                        {inspectionNozzle === "YES" && (
                                                            <>
                                                                {/* Only for End Connection → Show Inspection Nozzle Position (disabled) */}
                                                                {headerConnection === "End Connection" && Number(headerDia) > 114.3 &&
                                                                    renderInputField(
                                                                        "Inspection Nozzle Position",
                                                                        inspectionNozzlePosition,
                                                                        setInspectionNozzlePosition,
                                                                        "text",
                                                                        ["Left", "Right"],
                                                                        null,
                                                                        "",
                                                                        { disabled: true }
                                                                    )
                                                                }

                                                                {/* Show OD / Thk / Material based on the condition */}
                                                                {(
                                                                    (headerConnection === "Branch Connection" && Number(headerDia) > 114.3) ||
                                                                    (headerConnection === "End Connection" && Number(headerDia) > 114.3)
                                                                ) && (
                                                                        <>
                                                                            {renderInputField(
                                                                                "Inspection Nozzle OD",
                                                                                inspectionNozzleOD,
                                                                                setInspectionNozzleOD,
                                                                                "number", null, "Inspection_Nozzle_Required"
                                                                            )}

                                                                            {renderInputField(
                                                                                "Inspection Nozzle Thk",
                                                                                inspectionNozzleThk,
                                                                                setInspectionNozzleThk,
                                                                                "number", null, "Inspection_Nozzle_Required"
                                                                            )}

                                                                            {renderInputField(
                                                                                "Inspection Nozzle Material",
                                                                                inspectionNozzleMaterial,
                                                                                setInspectionNozzleMaterial,
                                                                                "text",
                                                                                [
                                                                                    "SA 515/516 Gr.60/70/SA 105",
                                                                                    "SA 106 GR B",
                                                                                    "SA 106 GR C",
                                                                                    "SA 335 GR P11",
                                                                                    "SA 335 GR P22",
                                                                                    "SA 335 GR P91",
                                                                                    "SA 312 GR TP304",
                                                                                    "SA 312 GR TP304L",
                                                                                    "SA 312 GR TP304H",
                                                                                    "SA 312 GR TP310H",
                                                                                    "SA 312 GR TP316L",
                                                                                    "SA 312 GR TP316",
                                                                                    "SA 312 GR TP316H",
                                                                                    "SA 312 GR TP321",
                                                                                    "SA 312 GR TP321H",
                                                                                    "SA 312 GR TP347",
                                                                                    "SA 312 GR TP347H"
                                                                                ]
                                                                            )}
                                                                        </>
                                                                    )}
                                                            </>
                                                        )}





                                                        {renderInputField(
                                                            "Baffle Pad Requirement",
                                                            bafflePadRequired,
                                                            setBafflePadRequired,
                                                            "text",
                                                            ["YES", "NO"], "Baffle_Pad_Requirement"
                                                        )}

                                                        {/* Conditionally render the rest only if 'Yes' */}
                                                        {bafflePadRequired === "YES" && (
                                                            <>
                                                                {renderInputField("Baffle Pad Width", bafflePadWidth, setBafflePadWidth, "number", null, "Baffle_Pad_Requirement")}
                                                                {renderInputField("Baffle Pad Thick", bafflePadThick, setBafflePadThick, "number", null, "Baffle_Pad_Requirement")}
                                                                {renderInputField("Baffle Pad Material", bafflePadMaterial, setBafflePadMaterial, "text", ["SA 516 GR 60", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}
                                                                {renderInputField("Baffle Pad Orientation", bafflePadOrientation, setBafflePadOrientation, "number", null, "Baffle_Pad_Requirement")}
                                                                {renderInputField("Baffle Pad Length", bafflePadLength, setBafflePadLength, "number", null, null, "", { disabled: true })}
                                                            </>
                                                        )}



                                                        {renderInputField(
                                                            "Expansion Indicator Pad Requirement",
                                                            expPadRequired,
                                                            setExpPadRequired,
                                                            "text",
                                                            ["YES", "NO"]
                                                        )}

                                                        {/* Conditionally render the rest if 'Yes' */}
                                                        {expPadRequired === "YES" && (
                                                            <>
                                                                {renderInputField(
                                                                    "Expansion Indicator Pad placement",
                                                                    expPadLocation,
                                                                    setExpPadLocation,
                                                                    "text",
                                                                    ["Header", "Inspection Nozzle"]
                                                                )}
                                                                {renderInputField(
                                                                    "Expansion Indicator Pad Location",
                                                                    expPadLocNew,
                                                                    setExpPadLocNew,
                                                                    "text"
                                                                )}
                                                                {renderInputField("Expansion Indicator Pad Length", expPadLength, setExpPadLength, "number")}
                                                                {renderInputField("Expansion Indicator Pad Thk", expPadThk, setExpPadThk, "number")}
                                                                {renderInputField("Expansion Indicator Pad Material", expPadMaterial, setExpPadMaterial, "text", ["SA 516 GR 60", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}
                                                            </>
                                                        )}


                                                        {headerConnection === "Branch Connection" && (
                                                            <>
                                                                {renderInputField(
                                                                    "No of Branch",
                                                                    branchDistanceArray.length.toString(),
                                                                    (val) => {
                                                                        const count = parseInt(val);
                                                                        if (!isNaN(count) && count > 0) {
                                                                            // Update array size dynamically
                                                                            setBranchDistanceArray((prev) => {
                                                                                const updated = [...prev];
                                                                                if (count > updated.length) {
                                                                                    return [...updated, ...Array(count - updated.length).fill("")];
                                                                                } else {
                                                                                    return updated.slice(0, count);
                                                                                }
                                                                            });
                                                                        }
                                                                    },
                                                                    "text",
                                                                    Array.from({ length: 18 }, (_, i) => (i + 1).toString()), "Branch_Type" // 1–18 options
                                                                )}

                                                                {branchDistanceArray.map((branch, index) => (
                                                                    <React.Fragment key={index}>
                                                                        {index === 0
                                                                            ? renderInputField(
                                                                                `Dist from Header End to 1st Branch`,
                                                                                branch,
                                                                                (val) => {
                                                                                    const updated = [...branchDistanceArray];
                                                                                    updated[index] = val;
                                                                                    setBranchDistanceArray(updated);
                                                                                },
                                                                                "number",
                                                                                null,
                                                                                null,
                                                                                "",
                                                                                {
                                                                                    onFocus: () => setImageSrc(require("./Images/Header_end_dist_from_Last_Coil_D1_D2.png")),
                                                                                }
                                                                            )
                                                                            : renderInputField(
                                                                                `Branch (${index + 1}) Dist from last branch`,
                                                                                branch,
                                                                                (val) => {
                                                                                    const updated = [...branchDistanceArray];
                                                                                    updated[index] = val;
                                                                                    setBranchDistanceArray(updated);
                                                                                },
                                                                                "number",
                                                                                null,
                                                                                null,
                                                                                "",
                                                                                {
                                                                                    onFocus: () => setImageSrc(require("./Images/Header_end_dist_from_Last_Coil_D1_D2.png")),
                                                                                }
                                                                            )}
                                                                    </React.Fragment>
                                                                ))}

                                                                {renderInputField("Branch Type", branchType, setBranchType, "text", ["Straight", "Bend"])}

                                                                {/* Conditionally render fields based on Branch Type */}
                                                                {branchType === "Straight" && renderInputField("Branch Length", branchLength, setBranchLength, "number")}
                                                                {branchType === "Bend" && (
                                                                    <>
                                                                        {renderInputField("Branch Distance (X)", branchDistanceX, setBranchDistanceX, "number")}
                                                                        {renderInputField("Branch Distance (Y)", branchDistanceY, setBranchDistanceY, "number")}
                                                                        {renderInputField("Branch Radius", branchRadius, setBranchRadius, "number")}
                                                                    </>
                                                                )}


                                                                {renderInputField("Branch Angle", branchAngle, setBranchAngle, "number")}
                                                                {renderInputField("Branch OD", branchOD, setBranchOD, "number")}
                                                                {renderInputField("Branch Thk", branchThk, setBranchThk, "number")}
                                                                {renderInputField("Connecting Pipe ID Size for Branch", connectingPipeSize, setConnectingPipeSize, "number", null, "Header_Connecting_Pipe_ID")}
                                                                {renderInputField("Connecting Pipe Thk for Branch", connectingPipeThk, setConnectingPipeThk, "number", null, "Header_Connecting_Pipe_ID")}
                                                                {renderInputField("Branch Material", branchMaterial, setBranchMaterial, "text", ["SA 106 GR B", "SA 106 GR C", "SA 335 GR P11", "SA 335 GR P22", "SA 335 GR P91", "SA 312 GR TP304", "SA 312 GR TP304L", "SA 312 GR TP304H", "SA 312 GR TP310H", "SA 312 GR TP316L", "SA 312 GR TP316", "SA 312 GR TP316H", "SA 312 GR TP321", "SA 312 GR TP321H", "SA 312 GR TP347", "SA 312 GR TP347H"])}

                                                                {/* Branch Pad Requirement */}
                                                                {renderInputField("Branch Pad Requirement", branchPadRequired, setBranchPadRequired, "text", ["YES", "NO"], "Branch_Pad_Requirement")}

                                                                {/* Conditionally render Branch Pad fields if required */}
                                                                {branchPadRequired === "YES" && (
                                                                    <>
                                                                        {renderInputField("Branch Pad Width", branchPadWidth, setBranchPadWidth, "number", null, "Branch_Pad_Requirement")}
                                                                        {renderInputField("Branch Pad Thick", branchPadThk, setBranchPadThk, "number", null, "Branch_Pad_Requirement")}
                                                                        {renderInputField("Branch Pad Material", branchPadMaterial, setBranchPadMaterial, "text", ["SA 106 GR B", "SA 516 GR 70", "SA 106 GR C", "SA 335 GR P11", "SA 335 GR P22", "SA 335 GR P91", "SA 312 GR TP304", "SA 312 GR TP304L", "SA 312 GR TP304H", "SA 312 GR TP310H", "SA 312 GR TP316L", "SA 312 GR TP316", "SA 312 GR TP316H", "SA 312 GR TP321", "SA 312 GR TP321H", "SA 312 GR TP347", "SA 312 GR TP347H"])}
                                                                        {renderInputField("Branch Pad Distance from Branch End", branchPadDistance, setBranchPadDistance, "number", null, "Branch_Pad_Requirement")}

                                                                    </>
                                                                )}
                                                            </>
                                                        )}

                                                        {headerConnection === "End Connection" && (
                                                            <>
                                                                {renderInputField("Connecting Pipe ID Size for Header End", connectingPipeSize_Head_End, setConnectingPipeSize_Head_End, "number", null, "Header_Connecting_Pipe_ID")}
                                                                {renderInputField("Connecting Pipe Thk for Header End", connectingPipeThk_Head_End, setConnectingPipeThk_Head_End, "number", null, "Header_Connecting_Pipe_ID")}
                                                            </>
                                                        )}

                                                        {renderInputField(
                                                            "Vent Nozzle Requirement",
                                                            ventNozzleReq,
                                                            setVentNozzleReq,
                                                            "text",
                                                            ["YES", "NO"], "Header_end_dist_from_Last_Coil_D1_D2"
                                                        )}


                                                        {ventNozzleReq === "YES" && (
                                                            <>
                                                                {renderInputField(
                                                                    "Vent Nozzle Position",
                                                                    ventNozzlePosition,
                                                                    setVentNozzlePosition,
                                                                    "text",
                                                                    ["Left", "Right", "Both"]
                                                                )}
                                                                {renderInputField(
                                                                    "Vent Nozzle Location",
                                                                    ventNozzleLocation,
                                                                    setVentNozzleLocation,
                                                                    "text"
                                                                )}
                                                                {renderInputField(
                                                                    "Vent Nozzle OD",
                                                                    ventNozzleOD,
                                                                    setVentNozzleOD,
                                                                    "number", null, "Vent_Nozzle_Requirement"
                                                                )}
                                                                {renderInputField(
                                                                    "Vent Nozzle Thk",
                                                                    ventNozzleThk,
                                                                    setVentNozzleThk,
                                                                    "number", null, "Vent_Nozzle_Requirement"
                                                                )}
                                                                {renderInputField(
                                                                    "Vent Nozzle Material",
                                                                    ventNozzleMaterial,
                                                                    setVentNozzleMaterial,
                                                                    "text",
                                                                    ["SA 192","SA 106 GR B", "SA 210 GR A1", "SA 179", "SA 210 GR C", "SA 213 GR T11", "SA 213 GR T22", "SA 213 GR T91", "SA 213 GR TP304H", "SA 213 GR TP310H", "SA 213 GR TP310HCBN", "SA 213 GR TP316", "SA 213 GR TP347H", "SA 213 GR TP347HFG"]
                                                                )}
                                                                {renderInputField(
                                                                    "Vent Nozzle Length",
                                                                    ventNozzleLength,
                                                                    setVentNozzleLength,
                                                                    "number", null, "Vent_Nozzle_Requirement"
                                                                )}
                                                                {renderInputField(
                                                                    "Connecting Pipe ID Size for Vent",
                                                                    connectingPipeSizeVent,
                                                                    setConnectingPipeSizeVent,
                                                                    "number", null, "Header_Connecting_Pipe_ID"
                                                                )}
                                                                {renderInputField(
                                                                    "Connecting Pipe Thk for Vent",
                                                                    connectingPipeThkVent,
                                                                    setConnectingPipeThkVent,
                                                                    "number", null, "Header_Connecting_Pipe_ID"
                                                                )}

                                                            </>
                                                        )}

                                                    </Box>

                                                )}


                                                {headerTab === 1 && (
                                                    <Box sx={{ display: "flex", flexDirection: "column", mat: 1 }}>
                                                        {/*{renderInputField("Header Position (C)", headerPosC_Det_Btm, setHeaderPosC_Det_Btm, "text", ["LHS", "RHS"], "header bottom pos")}*/}

                                                        {renderInputField("Header Location", headerLocD_Det_Btm, setHeaderLocD_Det_Btm, "text", ["In_Side_Casing", "Out_Side_Casing"], "HeaderBottomLoc")}
                                                        {/*{renderInputField("Header Stub Variant", headerStubVariant_Btm, setHeaderStubVariant_Btm, "text", ["Short", "Long"])}*/}

                                                        {renderInputField("Header Height from CL of Coil", heightFromCoil_Btm, setHeightFromCoil_Btm, "text")}
                                                        {renderInputField("Distance from Casing ID", distanceFromCasingID_Btm, setDistanceFromCasingID_Btm, "text")}

                                                        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mb: 4 }}>
                                                            {headerStubs_Btm.map((stub, index) => {

                                                                // ✅ Correct place to declare this
                                                                const selectedImage_Btm = getStubEndPointBtmImage(headerPosC, stub.type);

                                                                return (
                                                                    <Box
                                                                        key={index}
                                                                        sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}
                                                                    >
                                                                        <h4 style={{ color: "white", marginBottom: "10px" }}>
                                                                            Header Stub –{index + 1}
                                                                        </h4>

                                                                        {renderInputField(
                                                                            `Header Stub –${index + 1} Type`,
                                                                            stub.type,
                                                                            (val) => {
                                                                                const newStubs = [...headerStubs_Btm];
                                                                                newStubs[index].type = val;
                                                                                setHeaderStubs_Btm(newStubs);
                                                                            },
                                                                            "number",
                                                                            ["1", "2"],
                                                                            "Header_Stub_Types"
                                                                        )}

                                                                        {renderInputField(
                                                                            `Header Stub–${index + 1} Angle`,
                                                                            stub.angle,
                                                                            (val) => {
                                                                                const newStubs = [...headerStubs_Btm];
                                                                                newStubs[index].angle = val;
                                                                                setHeaderStubs_Btm(newStubs);
                                                                                updateStubAngleImage_Btm(index);
                                                                            },
                                                                            "number",
                                                                            null,
                                                                            null,
                                                                            "",
                                                                            {
                                                                                onClick: () => updateStubAngleImage_Btm(index),
                                                                            }  // 🔹 FOCUS HANDLER
                                                                        )}


                                                                        {despatch === "Non Modular" && (
                                                                            renderInputField(
                                                                                `Header Stub–${index + 1} Weld Position`,
                                                                                stub.weldPos,
                                                                                (val) => {
                                                                                    const newStubs = [...headerStubs_Btm];
                                                                                    newStubs[index].weldPos = val;
                                                                                    setHeaderStubs_Btm(newStubs);
                                                                                },
                                                                                "number", null, "Header_Stub_Weld_Position_Btm1_5"
                                                                            )
                                                                        )}


                                                                        {stub.type === "1" &&
                                                                            renderInputField(
                                                                                `Stub–${index + 1} Dist from Header CL`,
                                                                                stub.distance,
                                                                                (val) => {
                                                                                    const newStubs = [...headerStubs_Btm];
                                                                                    newStubs[index].distance = val;
                                                                                    setHeaderStubs_Btm(newStubs);
                                                                                },
                                                                                "number", null, "Stub_Dist_from_Header_CL_Btm"
                                                                            )}


                                                                        {tubeType === "Finned" && (
                                                                            renderInputField(
                                                                                `Stub –${index + 1} End Point Distance`,
                                                                                stub.dist_Pt,
                                                                                (val) => {
                                                                                    const newStubs = [...headerStubs_Btm];
                                                                                    newStubs[index].dist_Pt = val;
                                                                                    setHeaderStubs_Btm(newStubs);
                                                                                },
                                                                                "number",
                                                                                null,
                                                                                selectedImage_Btm   // 👈 pass resolved image key here
                                                                            )
                                                                        )}

                                                                    </Box>
                                                                );
                                                            })}

                                                        </Box>

                                                        {renderInputField("Header end dist from Last Coil-D1", headerEndDistD1_Btm, setHeaderEndDistD1_Btm, "number", null, "Header_end_dist_from_Last_Coil_D1_D2")}
                                                        {renderInputField("Header end dist from Last Coil-D2", headerEndDistD2_Btm, setHeaderEndDistD2_Btm, "number", null, "Header_end_dist_from_Last_Coil_D1_D2")}
                                                        {renderInputField("Header Connection", headerConnection_Btm, setHeaderConnection_Btm, "text", ["End Connection", "Branch Connection"])}

                                                        {renderInputField("Field Weld between Header", fieldWeldBetweenHeader_Btm, setFieldWeldBetweenHeader_Btm, "text", ["YES", "NO"], "Field_Weld_between_Header")}

                                                        {fieldWeldBetweenHeader_Btm === "YES" && (
                                                            <>
                                                                {renderInputField("No of Field Weld", noOfFieldWeld_Btm, setNoOfFieldWeld_Btm, "number", ["1", "2", "3"])}

                                                                {noOfFieldWeld_Btm === "1" && renderInputField("Coil Rows covered for Field Weld-1", fieldWeldLoc1_Btm, setFieldWeldLoc1_Btm, "text")}
                                                                {noOfFieldWeld_Btm === "2" && (
                                                                    <>
                                                                        {renderInputField("Coil Rows covered for Field Weld-1", fieldWeldLoc1_Btm, setFieldWeldLoc1_Btm, "text")}
                                                                        {renderInputField("Coil Rows covered for Field Weld-2", fieldWeldLoc2_Btm, setFieldWeldLoc2_Btm, "text")}
                                                                    </>
                                                                )}
                                                                {noOfFieldWeld_Btm === "3" && (
                                                                    <>
                                                                        {renderInputField("Coil Rows covered for Field Weld-1", fieldWeldLoc1_Btm, setFieldWeldLoc1_Btm, "text")}
                                                                        {renderInputField("Coil Rows covered for Field Weld-2", fieldWeldLoc2_Btm, setFieldWeldLoc2_Btm, "text")}
                                                                        {renderInputField("Coil Rows covered for Field Weld-3", fieldWeldLoc3_Btm, setFieldWeldLoc3_Btm, "text")}

                                                                    </>
                                                                )}
                                                            </>
                                                        )}

                                                        {renderInputField("Header Seal Pad Requirement", sealPadRequired_Btm, setSealPadRequired_Btm, "text", ["YES", "NO"], "Header_Seal_Pad_Requirement")}
                                                        {sealPadRequired_Btm === "YES" && (
                                                            <>
                                                                {renderInputField("Header Seal Pad Width", sealPadWidth_Btm, setSealPadWidth_Btm, "number", null, "Header_Seal_Pad_Requirement")}
                                                                {renderInputField("Header Seal Pad Thick", sealPadThick_Btm, setSealPadThick_Btm, "number", null, "Header_Seal_Pad_Requirement")}
                                                                {renderInputField("Header Seal Pad Material", sealPadMaterial_Btm, setSealPadMaterial_Btm, "text", ["SA 106 GR B", "SA 516 GR 70", "SA 106 GR C", "SA 335 GR P11", "SA 335 GR P22", "SA 335 GR P91", "SA 312 GR TP304", "SA 312 GR TP304L", "SA 312 GR TP304H", "SA 312 GR TP310H", "SA 312 GR TP316L", "SA 312 GR TP316", "SA 312 GR TP316H", "SA 312 GR TP321", "SA 312 GR TP321H", "SA 312 GR TP347", "SA 312 GR TP347H"])}
                                                                {renderInputField("Header Seal Pad Dist from Header End(D3)", sealPadDistance_Btm, setSealPadDistance_Btm, "number", null, "Header_end_dist_from_Last_Coil_D1_D2")}
                                                                {renderInputField("Header Seal Pad Dist from Header End(D4)", sealPadDistance_Btm1, setSealPadDistance_Btm1, "number", null, "Header_end_dist_from_Last_Coil_D1_D2")}

                                                            </>
                                                        )}

                                                        {headerConnection_Btm === "End Connection" && (
                                                            renderInputField(
                                                                "Header End Plate Position",
                                                                endPlatePosition_Btm,
                                                                (val) => {
                                                                    setEndPlatePosition_Btm(val);

                                                                    // Automatically sync Inspection Nozzle Position
                                                                    setInspectionNozzlePosition_Btm(val);
                                                                },
                                                                "text",
                                                                ["Left", "Right"]
                                                            )
                                                        )}


                                                        {renderInputField("Header End Plate Thk", endPlateThk_Btm, setEndPlateThk_Btm, "number", null, "Header_End_Plate_Thk")}
                                                        {renderInputField("Header End Plate Material", endPlateMaterial_Btm, setEndPlateMaterial_Btm, "text", ["SA 516 GR 60", "SA 105", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}


                                                        {/* If Bottom Header Connection → Show Inspection Nozzle Required */}
                                                        {(
                                                            (headerConnection_Btm === "Branch Connection" && Number(headerDiaBtm) > 114.3) ||
                                                            (headerConnection_Btm === "End Connection" && Number(headerDiaBtm) > 114.3)
                                                        ) && (
                                                                renderInputField(
                                                                    "Inspection Nozzle Required",
                                                                    inspectionNozzle_Btm,
                                                                    setInspectionNozzle_Btm,
                                                                    "text",
                                                                    ["YES", "NO"], "Inspection_Nozzle_Required"
                                                                )
                                                            )}

                                                        {/* If YES → show Bottom-side fields */}
                                                        {inspectionNozzle_Btm === "YES" && (
                                                            <>

                                                                {/* For End Connection → show Position (Enabled / Disabled – your choice) */}
                                                                {headerConnection_Btm === "End Connection" && Number(headerDiaBtm) > 114.3 &&
                                                                    renderInputField(
                                                                        "Inspection Nozzle Position",
                                                                        inspectionNozzlePosition_Btm,
                                                                        setInspectionNozzlePosition_Btm,
                                                                        "text",
                                                                        ["Left", "Right"],
                                                                        null,
                                                                        "",
                                                                        { disabled: true }   // remove if you want it enabled
                                                                    )
                                                                }

                                                                {/* Show OD / Thk / Material based on condition */}
                                                                {(
                                                                    (headerConnection_Btm === "Branch Connection" && Number(headerDiaBtm) > 114.3) ||
                                                                    (headerConnection_Btm === "End Connection" && Number(headerDiaBtm) > 114.3)
                                                                ) && (
                                                                        <>
                                                                            {renderInputField(
                                                                                "Inspection Nozzle OD",
                                                                                inspectionNozzleOD_Btm,
                                                                                setInspectionNozzleOD_Btm,
                                                                                "number", null, "Inspection_Nozzle_Required"
                                                                            )}

                                                                            {renderInputField(
                                                                                "Inspection Nozzle Thk",
                                                                                inspectionNozzleThk_Btm,
                                                                                setInspectionNozzleThk_Btm,
                                                                                "number", null, "Inspection_Nozzle_Required"
                                                                            )}

                                                                            {renderInputField(
                                                                                "Inspection Nozzle Material",
                                                                                inspectionNozzleMaterial_Btm,
                                                                                setInspectionNozzleMaterial_Btm,
                                                                                "text",
                                                                                [
                                                                                    "SA 106 GR B",
                                                                                    "SA 106 GR C",
                                                                                    "SA 335 GR P11",
                                                                                    "SA 335 GR P22",
                                                                                    "SA 335 GR P91",
                                                                                    "SA 312 GR TP304",
                                                                                    "SA 312 GR TP304L",
                                                                                    "SA 312 GR TP304H",
                                                                                    "SA 312 GR TP310H",
                                                                                    "SA 312 GR TP316L",
                                                                                    "SA 312 GR TP316",
                                                                                    "SA 312 GR TP316H",
                                                                                    "SA 312 GR TP321",
                                                                                    "SA 312 GR TP321H",
                                                                                    "SA 312 GR TP347",
                                                                                    "SA 312 GR TP347H"
                                                                                ]
                                                                            )}
                                                                        </>
                                                                    )}
                                                            </>
                                                        )}


                                                        {renderInputField("Baffle Pad Requirement", bafflePadRequired_Btm, setBafflePadRequired_Btm, "text", ["YES", "NO"], "Baffle_Pad_Requirement")}
                                                        {bafflePadRequired_Btm === "YES" && (
                                                            <>
                                                                {renderInputField("Baffle Pad Width", bafflePadWidth_Btm, setBafflePadWidth_Btm, "number", null, "Baffle_Pad_Requirement")}
                                                                {renderInputField("Baffle Pad Thick", bafflePadThk_Btm, setBafflePadThk_Btm, "number", null, "Baffle_Pad_Requirement")}
                                                                {renderInputField("Baffle Pad Material", bafflePadMaterial_Btm, setBafflePadMaterial_Btm, "text", ["SA 516 GR 60", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}
                                                                {renderInputField("Baffle Pad Orientation", bafflePadOrientation_Btm, setBafflePadOrientation_Btm, "number", null, "Baffle_Pad_Requirement")}
                                                                {renderInputField("Baffle Pad Length", bafflePadLength_Btm, setBafflePadLength_Btm, "number", null, null, "", { disabled: true })}
                                                            </>
                                                        )}



                                                        {renderInputField("Expansion Indicator Pad Requirement", expPadRequired_Btm, setExpPadRequired_Btm, "text", ["YES", "NO"])}
                                                        {expPadRequired_Btm === "YES" && (
                                                            <>
                                                                {renderInputField("Expansion Indicator Pad Placement", expPadLocation_Btm, setExpPadLocation_Btm, "text", ["Header", "Inspection Nozzle"])}
                                                                {renderInputField("Expansion Indicator Pad Location", expPadLocNew_Btm, setExpPadLocNew_Btm, "text")}
                                                                {renderInputField("Expansion Indicator Pad Length", expPadLength_Btm, setExpPadLength_Btm, "number")}
                                                                {renderInputField("Expansion Indicator Pad Thk", expPadThk_Btm, setExpPadThk_Btm, "number")}
                                                                {renderInputField("Expansion Indicator Pad Material", expPadMaterial_Btm, setExpPadMaterial_Btm, "text", ["SA 516 GR 60", "SA 516 GR 70", "SA 515 GR 60", "SA 515 GR 70", "SA 299", "SA 387 GR 11(CL1 & 2)", "SA 387 GR 22(CL1 & 2)", "SA 387 GR 91 CL2", "SA 240 GR 304", "SA 240 GR 304L", "SA 240 GR 304H", "SA 240 GR 310H", "SA 240 GR 316L", "SA 240 GR 316", "SA 240 GR 316H", "SA 240 GR 321", "SA 240 GR 321H", "SA 240 GR 347", "SA 240 GR 347H"])}
                                                            </>
                                                        )}


                                                        {headerConnection_Btm === "Branch Connection" && (
                                                            <>

                                                                {renderInputField(
                                                                    "No of Branch",
                                                                    branchDistanceArray_Btm.length.toString(),
                                                                    (val) => {
                                                                        const count = parseInt(val);
                                                                        if (!isNaN(count) && count > 0) {
                                                                            // Dynamically resize array
                                                                            setBranchDistanceArray_Btm((prev) => {
                                                                                const updated = [...prev];
                                                                                if (count > updated.length) {
                                                                                    return [...updated, ...Array(count - updated.length).fill("")];
                                                                                } else {
                                                                                    return updated.slice(0, count);
                                                                                }
                                                                            });
                                                                        }
                                                                    },
                                                                    "text",
                                                                    Array.from({ length: 18 }, (_, i) => (i + 1).toString()), "Branch_Type" // options 1–18
                                                                )}

                                                                {branchDistanceArray_Btm.map((branch, index) => (
                                                                    <React.Fragment key={index}>
                                                                        {index === 0
                                                                            ? renderInputField(
                                                                                `Dist from Header End to 1st Branch`,
                                                                                branch,
                                                                                (val) => {
                                                                                    const updated = [...branchDistanceArray_Btm];
                                                                                    updated[index] = val;
                                                                                    setBranchDistanceArray_Btm(updated);
                                                                                },
                                                                                "number",
                                                                                null,
                                                                                null,
                                                                                "",
                                                                                {
                                                                                    onFocus: () => setImageSrc(require("./Images/Header_end_dist_from_Last_Coil_D1_D2.png")),
                                                                                }
                                                                            )
                                                                            : renderInputField(
                                                                                `Branch (${index + 1}) Dist from last branch`,
                                                                                branch,
                                                                                (val) => {
                                                                                    const updated = [...branchDistanceArray_Btm];
                                                                                    updated[index] = val;
                                                                                    setBranchDistanceArray_Btm(updated);
                                                                                },
                                                                                "number",
                                                                                null,
                                                                                null,
                                                                                "",
                                                                                {
                                                                                    onFocus: () => setImageSrc(require("./Images/Header_end_dist_from_Last_Coil_D1_D2.png")),
                                                                                }
                                                                            )}
                                                                    </React.Fragment>
                                                                ))}
                                                                {renderInputField("Branch Type", branchType_Btm, setBranchType_Btm, "text", ["Straight", "Bend"])}

                                                                {branchType_Btm === "Straight" && renderInputField("Branch Length", branchLength_Btm, setBranchLength_Btm, "number")}
                                                                {branchType_Btm === "Bend" && (
                                                                    <>
                                                                        {renderInputField("Branch Distance (X)", branchDistanceX_Btm, setBranchDistanceX_Btm, "number")}
                                                                        {renderInputField("Branch Distance (Y)", branchDistanceY_Btm, setBranchDistanceY_Btm, "number")}
                                                                        {renderInputField("Branch Radius", branchRadius_Btm, setBranchRadius_Btm, "number")}
                                                                    </>
                                                                )}


                                                                {renderInputField("Branch Angle", branchAngle_Btm, setBranchAngle_Btm, "number")}
                                                                {renderInputField("Branch OD", branchOD_Btm, setBranchOD_Btm, "number")}
                                                                {renderInputField("Branch Thk", branchThk_Btm, setBranchThk_Btm, "number")}
                                                                {renderInputField("Connecting Pipe ID Size for Branch", connectingPipeSize_Btm, setConnectingPipeSize_Btm, "number", null, "Header_Connecting_Pipe_ID")}
                                                                {renderInputField("Connecting Pipe Thk for Branch", connectingPipeThk_Btm, setConnectingPipeThk_Btm, "number", null, "Header_Connecting_Pipe_ID")}
                                                                {renderInputField("Branch Material", branchMaterial_Btm, setBranchMaterial_Btm, "text", ["SA 106 GR B", "SA 106 GR C", "SA 335 GR P11", "SA 335 GR P22", "SA 335 GR P91", "SA 312 GR TP304", "SA 312 GR TP304L", "SA 312 GR TP304H", "SA 312 GR TP310H", "SA 312 GR TP316L", "SA 312 GR TP316", "SA 312 GR TP316H", "SA 312 GR TP321", "SA 312 GR TP321H", "SA 312 GR TP347", "SA 312 GR TP347H"])}

                                                                {renderInputField("Branch Pad Requirement", branchPadRequired_Btm, setBranchPadRequired_Btm, "text", ["YES", "NO"], "Branch_Pad_Requirement")}
                                                                {branchPadRequired_Btm === "YES" && (
                                                                    <>
                                                                        {renderInputField("Branch Pad Width", branchPadWidth_Btm, setBranchPadWidth_Btm, "number", null, "Branch_Pad_Requirement")}
                                                                        {renderInputField("Branch Pad Thick", branchPadThk_Btm, setBranchPadThk_Btm, "number", null, "Branch_Pad_Requirement")}
                                                                        {renderInputField("Branch Pad Material", branchPadMaterial_Btm, setBranchPadMaterial_Btm, "text", ["SA 106 GR B", "SA 516 GR 70", "SA 106 GR C", "SA 335 GR P11", "SA 335 GR P22", "SA 335 GR P91", "SA 312 GR TP304", "SA 312 GR TP304L", "SA 312 GR TP304H", "SA 312 GR TP310H", "SA 312 GR TP316L", "SA 312 GR TP316", "SA 312 GR TP316H", "SA 312 GR TP321", "SA 312 GR TP321H", "SA 312 GR TP347", "SA 312 GR TP347H"])}
                                                                        {renderInputField("Branch Pad Distance from Branch End", branchPadDistance_Btm, setBranchPadDistance_Btm, "number", null, "Branch_Pad_Requirement")}

                                                                    </>
                                                                )}
                                                            </>
                                                        )}

                                                        {headerConnection_Btm === "End Connection" && (
                                                            <>
                                                                {renderInputField("Connecting Pipe ID Size for Header End", connectingPipeSize_Btm_Head_End, setConnectingPipeSize_Btm_Head_End, "number", null, "Header_Connecting_Pipe_ID")}
                                                                {renderInputField("Connecting Pipe Thk for Header End", connectingPipeThk_Btm_Head_End, setConnectingPipeThk_Btm_Head_End, "number", null, "Header_Connecting_Pipe_ID")}
                                                            </>
                                                        )}


                                                        {renderInputField("Drain Nozzle Requirement", drainNozzleReq_Btm, setDrainNozzleReq_Btm, "text", ["YES", "NO"], "Header_end_dist_from_Last_Coil_D1_D2")}
                                                        {drainNozzleReq_Btm === "YES" && (
                                                            <>
                                                                {renderInputField("Drain Nozzle Position", drainNozzlePosition_Btm, setDrainNozzlePosition_Btm, "text", ["Left", "Right", "Both"])}
                                                                {renderInputField("Drain Nozzle Location", drainNozzleLocation_Btm, setDrainNozzleLocation_Btm, "text")}
                                                                {renderInputField("Drain Nozzle OD", drainNozzleOD_Btm, setDrainNozzleOD_Btm, "number", null, "Drain_Nozzle_Requirement")}
                                                                {renderInputField("Drain Nozzle Thk", drainNozzleThk_Btm, setDrainNozzleThk_Btm, "number", null, "Drain_Nozzle_Requirement")}
                                                                {renderInputField("Drain Nozzle Material", drainNozzleMaterial_Btm, setDrainNozzleMaterial_Btm, "text", ["SA 106 GR B", "SA 192", "SA 210 GR A1", "SA 179", "SA 210 GR C", "SA 213 GR T11", "SA 213 GR T22", "SA 213 GR T91", "SA 213 GR TP304H", "SA 213 GR TP310H", "SA 213 GR TP310HCBN", "SA 213 GR TP316", "SA 213 GR TP347H", "SA 213 GR TP347HFG"])}
                                                                {renderInputField("Drain Nozzle Length", drainNozzleLength_Btm, setDrainNozzleLength_Btm, "number", null, "Drain_Nozzle_Requirement")}
                                                                {renderInputField("Connecting Pipe ID Size for Drain", connectingPipeSizeDrain_Btm, setConnectingPipeSizeDrain_Btm, "number", null, "Header_Connecting_Pipe_ID")}
                                                                {renderInputField("Connecting Pipe Thk for Drain", connectingPipeThkDrain_Btm, setConnectingPipeThkDrain_Btm, "number", null, "Header_Connecting_Pipe_ID")}

                                                            </>
                                                        )}

                                                        <Box sx={{ mt: 3, textAlign: "center" }}>
                                                            <Button variant="contained" onClick={() => executeDetailing("Header")} sx={{ fontSize: "1.1rem", px: 4, py: 1.5 }}>
                                                                Execute
                                                            </Button>
                                                        </Box>
                                                    </Box>
                                                )}
                                            </Box>
                                        )}
                                    </>
                                )}

                                {mainDetailTab === 1 && (
                                    <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>

                                        {/* Radio Buttons */}
                                        <FormControl component="fieldset" sx={{ mb: 2 }}>
                                            <RadioGroup
                                                row
                                                value={componentMode}
                                                onChange={(e) => setComponentMode(e.target.value)}
                                            >
                                                <FormControlLabel
                                                    value="Individual"
                                                    control={<Radio sx={{ color: "white", "&.Mui-checked": { color: "white" } }} />}
                                                    label="Individual"
                                                    sx={{ "& .MuiFormControlLabel-label": { color: "white" } }}
                                                />
                                                <FormControlLabel
                                                    value="Combined"
                                                    control={<Radio sx={{ color: "white", "&.Mui-checked": { color: "white" } }} />}
                                                    label="Combined"
                                                    sx={{ "& .MuiFormControlLabel-label": { color: "white" } }}
                                                />
                                            </RadioGroup>
                                        </FormControl>

                                        {/* Combined - keep existing content same */}
                                        {componentMode === "Combined" && (
                                            <>
                                                {renderInputField("No of Components", noOfComponentsDet, (val) => {
                                                    setNoOfComponentsDet(val);
                                                    const count = parseInt(val);
                                                    setCompNameArrayDet(Array(count).fill(""));
                                                    setCompDistanceArrayDet(Array(count - 1).fill(""));
                                                }, "text", ["2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"])}

                                                {compNameArrayDet.map((_, index) => (
                                                    <React.Fragment key={index}>
                                                        {renderInputField(`Component - C${index + 1}`, compNameArrayDet[index], (val) => {
                                                            const updated = [...compNameArrayDet];
                                                            updated[index] = val;
                                                            setCompNameArrayDet(updated);
                                                        })}

                                                        {index < compDistanceArrayDet.length && renderInputField(`Gap B/W Components (C${index + 1}-C${index + 2})`, compDistanceArrayDet[index], (val) => {
                                                            const updatedDistances = [...compDistanceArrayDet];
                                                            updatedDistances[index] = val;
                                                            setCompDistanceArrayDet(updatedDistances);
                                                        })}
                                                    </React.Fragment>
                                                ))}

                                                <Box sx={{ mt: 3, textAlign: "center" }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => executeDetailing("GA Assembly")}
                                                        sx={{ fontSize: "1.1rem", px: 4, py: 1.5 }}
                                                    >
                                                        Execute
                                                    </Button>
                                                </Box>
                                            </>
                                        )}

                                        {/* Individual - keep empty */}
                                        {componentMode === "Individual" && (
                                            <>
                                                {renderInputField("Component Name", componentName_Ind, setComponentName_Ind, "text")}

                                               
                                                        {/* 👉 Only hide this for PH */}
                                                        {boilerType?.toUpperCase() !== "PH" && (
                                                            <>
                                                                {renderInputField(
                                                                    "Tie Member Support Req.",
                                                                    tieMember_Req,
                                                                    setTieMember_Req,
                                                                    "text",
                                                                    ["YES", "NO"]
                                                                )}

                                                                {tieMember_Req === "YES" && (
                                                                    renderInputField(
                                                                        "Distance B/W Coil & Member",
                                                                        tieMemberToCoilDist,
                                                                        setTieMemberToCoilDist,
                                                                        "number"
                                                                    )
                                                                )}
                                                            </>
                                                        )}

                                                        {/* 👉 ALWAYS visible (including PH) */}
                                                        {renderInputField(
                                                            "Bottom Lug Requirement",
                                                            lug_Req,
                                                            setLug_Req,
                                                            "text",
                                                            ["YES", "NO"]
                                                        )}
                                                  


                                                
                                                

                                                {renderInputField("Assembly Dwg No", assemblyDwgNo, setAssemblyDwgNo, "number")}
                                                {renderInputField("Fabrication Dwg No", fabricationDwgNo, setFabricationDwgNo, "number")}
                                                {renderInputField("Header Dwg No", headerDwgNo, setHeaderDwgNo, "number")}
                                                {renderInputField("FAB BOM Item Code", fabBomItemCode, setFabBomItemCode, "text")}
                                                {renderInputField("Header BOM Item Code", headerBomItemCode, setHeaderBomItemCode, "text")}

                                                <Box sx={{ mt: 3, textAlign: "center" }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => executeDetailing("GA Assembly")}
                                                        sx={{ fontSize: "1.1rem", px: 4, py: 1.5 }}
                                                    >
                                                        Execute
                                                    </Button>
                                                </Box>
                                            </>
                                        )}

                                    </Box>
                                )}
                            </>
                        )}


                        <Snackbar open={snack.open} autoHideDuration={3000} onClose={() => setSnack({ ...snack, open: false })}>
                            <Alert severity={snack.severity} onClose={() => setSnack({ ...snack, open: false })} sx={{ width: "100%" }}>
                                {snack.message}
                            </Alert>
                        </Snackbar>
                    </Box>
                </Box>


                {/* Sticky Image Panel */}

                <Box
                    sx={{
                        width: "32%",               // Horizontal space
                        height: "100vh",            // Full vertical height
                        position: "sticky",
                        top: 0,
                        p: 0,
                        backgroundColor: "#f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <Paper
                        elevation={4}
                        sx={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#EBF2FD",  // ✅ white background
                            p: 3,                        // ✅ padding (around all sides)
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxSizing: "border-box"      // ✅ ensures padding counts inside box
                        }}
                    >
                        <img
                            src={imageSrc}
                            alt="Preview"
                            style={
                                imageSrc === DEFAULT_IMAGE
                                    ? {
                                        width: "100%",   // 🔴 stretch default image
                                        height: "105%",
                                        objectFit: "cover",
                                        display: "block",
                                    }
                                    : {
                                        maxWidth: "100%", // 🔴 center other images
                                        maxHeight: "100%",
                                        objectFit: "contain",
                                        display: "block",
                                    }
                            }
                        />
                    </Paper>

                </Box>

            </Box>

        </ThemeProvider>
    );
};

export default InventorControlPanel;
